// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./font.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./reset.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./common.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./content.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./community.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!./login.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js!./download.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/img_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/img_logo_beyoundX_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/icon_menu.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/icon_refresh@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/icon_set@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/icon_alarm@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/icon_profile@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/icon_logo_ls_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/icon_arrow_secondary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/no_alarm.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/icon_nav_d.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/icon_nav_u.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/icon_page_go.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/icon_select_l.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/Icon_search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/icon_deletecircle@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/icon_arrowsmall.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/iocn_closesmall.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/icon_treesub1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/icon_treesub2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/icon_treesub3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/icon_treesub4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/icon_treesub1_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/icon_treesub2_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/icon_treesub3_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/icon_treesub4_on.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/icon_treeopen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/icon_tree_m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/icon_tree_p.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/icon_arrow_gray10.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/********************************************** sub **********************************************/
#wrap {
  position: absolute;
  width: 100%;
  min-width: 19.938rem;
  min-height: 100%;
  background-color: #fff;
  overflow-x: hidden;
}
#wrap:not(.email, .randing, .intro, .page-market) {
  background-color: #e9edef;
}

/* header */
header {
  background-color: #0a78ff;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  /* z-index: 21; */
  z-index: 11;
}
/* sei - 마켓플레이스 */
#wrap.page-market > header {
  background-color: #fff;
  height: 62px;
  border-bottom: 1px solid #dde2e9;
}
header h1 {
  width: 237.6px;
  height: 100%;
  margin-left: 4px;
  font-size: 1.25rem;
  font-weight: 900;
  color: #fff;
}
.header__title {
  font-size: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: 100%;
}
/* beyoundx */
.header__title.beyoundx {
  width: 192.22px;
  height: 26px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: contain;
}
.header__left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  flex: 2;
}
.navbar__toggleBtn {
  width: 50px;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
  background-size: 1.75rem 1.75rem;
}
.navbar__toggleBtn.active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center #0050b8;
  background-size: 1.75rem 1.75rem;
}
.header__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  margin-right: 16px;
}
header time {
  font-size: 0.875rem;
  color: #fff;
}
.header__etc {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
}
.header__etc li {
  width: auto;
  height: 2.5rem;
  text-align: center;
  display: flex;
  align-items: center;
  /* margin-right: 15px; */
}
/* .header__etc li:last-child {
  margin-right: 10px;
}
.header__etc li:last-child a.btn-admin {
  margin-right: 5px;
} */
.header__etc li a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
}
.header__etc li a.btn-refresh {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
  background-size: 36px;
}
.header__etc li a.btn-set {
  position: relative;
  width: 40px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
  background-size: 36px;
}
.header__etc li a.btn-alarm {
  position: relative;
  width: 40px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
  background-size: 36px;
}
.header__etc li a.btn-alarm p {
  position: absolute;
  top: 0.188rem;
  left: 1.2rem;
  padding: 0 3px 0 2px;
  height: 0.938rem;
  min-width: 10px;
  background-color: #f55547;
  border-radius: 45px;
  color: #fff;
  font-size: 0.625rem;
  text-align: center;
  line-height: 0.95rem;
}
.header__etc li a.btn-admin {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 0 center;
  background-size: 2.25rem 2.25rem;
}
.header__etc li a.btn-admin span {
  font-size: 1rem;
  font-weight: 700;
  margin-left: 38px;
}
.header__etc li .go-sei {
  margin-right: 15px;
}
.header__etc li.active a {
  background-color: #0050b8;
  border-radius: 2px;
}
.header__etc li.active a.btn-admin {
  background-color: transparent;
}
.header__logo {
  margin-left: 24px;
  width: 46px;
  height: 22px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center center;
  background-size: 100%;
  opacity: 0.7;
}
.header__setting {
  position: absolute;
  top: 50px;
  right: 160px;
  width: auto;
  padding: 16px;
  background: #2a2c2f;
  border: 1px solid #576274;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.5);
  z-index: 3;
}
.header__setting.open {
  display: block;
}
.header__setting li {
  margin-bottom: 1.5rem;
}
.header__setting li:last-child {
  margin-bottom: 0.25rem;
}
.header__setting li p {
  font-weight: 500;
  font-size: 0.937rem;
  line-height: 0.875rem;
  letter-spacing: -0.4px;
  color: #ffffff;
  margin-bottom: 0.875rem;
}
.header__setting li .setting__btn {
  display: flex;
  justify-content: space-between;
}
.header__setting li .setting__btn button {
  width: 100%;
  min-width: 78px;
  padding: 0 10px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  padding: 0 10px;
  border: 0;
  border-radius: 0;
  background: #6b7891;
}
.header__setting li .setting__btn button:first-child {
  border-radius: 4px 0 0 4px;
}
.header__setting li .setting__btn button:last-child {
  border-radius: 0 4px 4px 0;
}
.header__setting li .setting__btn button span {
  color: #fff;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1;
}
.header__setting li .setting__btn button.on {
  background: #0a78ff;
}
.header__setting li .setting__btn button.on span {
  font-weight: 700;
}
.header__userinfo {
  position: absolute;
  top: 50px;
  right: 6px;
  width: 14.65rem;
  background: #2a2c2f;
  border: 1px solid #576274;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.5);
  z-index: 4;
}
.header__userinfo li {
  display: flex;
  align-items: center;
  height: auto;
  padding: 12px 0 13px;
  border-bottom: 1px solid #576274;
}
.header__userinfo li:last-child {
  border-bottom: 0;
}
.header__userinfo li a {
  display: flex;
  align-items: center;
  width: calc(100% - 32px);
  height: 100%;
  padding: 0 16px;
  font-weight: 500;
  font-size: 0.937rem;
  line-height: 0.875rem;
  letter-spacing: -0.025rem;
  color: #ffffff;
}
.header-etc-pop {
  display: none;
}
.header-etc-pop.active {
  display: block;
}
.header-etc-pop,
#wrap.page-market > header .header-etc-pop {
  position: absolute;
  top: 52px;
  left: 84px; /* 241126 수정 */
  width: 80px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(122, 133, 150, 0.5);
  border-radius: 4px;
  z-index: 4;
}
#wrap.page-market .header-etc-pop.header__userinfo {
  width: 152px;
  left: 0;
  border: 0;
}
#wrap.page-market .header__etc li {
  position: relative;
  gap: 16px;
  padding: 0;
  border: 0;
}
#wrap.page-market .header__etc li:last-child {
  margin-right: 0;
}
.header-etc-pop li {
  display: flex;
  align-items: center;
  height: auto;
}
.header-etc-pop li a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.14;
  letter-spacing: -0.02em;
  color: #2a2c2f;
}
#wrap.page-market .header-etc-pop li:hover a,
#wrap.page-market .header-etc-pop li:active a {
  font-weight: 500;
  color: #0a78ff;
  letter-spacing: -0.03em;
}
.header__etc .btn-lang {
  padding: 0 12px 0 12px; /* 241125 수정 */
  gap: 6px; /* 241125 수정 */
}
.header__etc .btn-lang:after {
  content: "";
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center center;
  background-size: 100%;
}
.header__etc .btn-lang.active:after {
  transform: scaleY(-1);
}
.btn-lang-nav {
  display: none;
}
.navbar.active .btn-lang-nav,
#wrap.page-market .navbar__menu li.btn-lang-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  bottom: 38px;
  right: 0;
  gap: 50px;
  margin: 0 20px;
  padding: 0 30px 0 0;
  width: calc(100% - 40px);
  border-top: 1px solid #dde2e9;
}
.navbar__menu li.btn-lang-nav > a,
#wrap.page-market .navbar__menu li.btn-lang-nav > a {
  padding: 0;
  margin-top: 18px;
  border: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #2a2c2f;
  letter-spacing: -0.04em;
}
.navbar__menu li.btn-lang-nav > a:hover,
.navbar__menu li.btn-lang-nav > a:active,
.navbar__menu li.btn-lang-nav > a.on,
#wrap.page-market .navbar__menu li.btn-lang-nav > a:hover,
#wrap.page-market .navbar__menu li.btn-lang-nav > a:active,
#wrap.page-market .navbar__menu li.btn-lang-nav > a.on {
  font-weight: 500;
  color: #0a78ff;
}

.header__alarm {
  position: absolute;
  top: 50px;
  right: 0;
  width: 28.937rem;
  height: calc(100vh - 50px);
  background: #2a2c2f;
  border: 1px solid #576274;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.5);
  z-index: 5;
  overflow-y: auto;
}
.header__alarm .nodata__txt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 13px;
  line-height: 14px;
  text-align: center;
  width: 100%;
  height: 80%;
  color: #8898b7;
}
.header__alarm .nodata__txt::before {
  content: "";
  margin-bottom: 16px;
  width: 106px;
  height: 100px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center;
}
.header__alarm p,
.header__alarm span {
  color: #fff;
}
.header__alarm .alarm__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
  border-bottom: 1px solid #646c74;
}
.header__alarm .alarm__top .title {
  font-weight: 700;
  font-size: 1rem;
  color: #fff;
}
.header__alarm .alarm__top .title span {
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #909fb7;
  margin-left: 1rem;
}
.header__alarm .alarm__top p {
  font-size: 12px;
  color: #0a78ff;
}
.header__alarm .alarm__top button {
  border: 0;
}
.header__alarm .alarm__top button span {
  font-weight: 400;
  font-size: 0.75rem;
  color: #0a78ff;
}
.header__alarm .alarm__top button:hover span {
  color: #9ac1ff;
}
.header__alarm .alarm__top button:active span {
  color: #fff;
}
.alarm__notice {
  padding: 9px 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.alarm__notice p {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #8898b7;
  height: 18px;
}
.alarm__notice button.btn-alarmread {
  padding: 3px 10px;
  background: #3e4858;
  border: 0;
  border-radius: 10px;
}
.alarm__notice button.btn-alarmread span {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #fff;
  font-weight: 400;
}
.alarm__notice button.btn-alarmread:hover {
  background: #6b7891;
}
.header__alarm .alarm__list li {
  border-bottom: 1px solid #646c74;
}
.header__alarm .alarm__list li:hover {
  background: #142c4c;
}
.header__alarm .alarm__list li:active {
  background: #1f3e68;
}
.header__alarm .alarm__list li a {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.header__alarm .alarm__list li a .list__name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.header__alarm .alarm__list li a .list__name button {
  position: relative;
  width: 16px;
  height: 16px;
  border: 4px solid #2a2c2f;
  background: #0a78ff;
  border-radius: 50px;
}
.header__alarm .alarm__list li a .list__name button:hover::before {
  content: "읽음으로 표시";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 22px;
  width: 85px;
  height: 18px;
  font-weight: 400;
  font-size: 12px;
  color: #2a2c2f;
  background: #dde2e9;
  border-radius: 10px;
  z-index: 1000;
}
.header__alarm .alarm__list li a .list__name button:hover:after {
  content: "";
  position: absolute;
  left: -5px;
  top: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50px;
  background: transparent;
  border: 1px solid#0A78FF;
}
.header__alarm .alarm__list li a .list__name button.readend {
  width: 16px;
  height: 16px;
  border: 1px solid #515d6f;
  background: transparent;
}
.header__alarm .alarm__list li a .list__name button.readend:hover:before {
  content: "읽지않음으로 표시";
  width: 108px;
  right: 24px;
}
.header__alarm .alarm__list li a .list__name button.readend:hover:after {
  content: none;
}
.header__alarm .alarm__list li a .list__name p {
  font-size: 15px;
  font-weight: 500;
  line-height: 0.875rem;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header__alarm .alarm__list li a .list__name .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.75rem;
  color: #2a2c2f;
  background: #dde2e9;
  border-radius: 10px;
  height: 15px;
  width: auto;
  padding: 2px 10px 1px;
  margin-left: 24px;
}
.header__alarm .alarm__list li a .list__info {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.header__alarm .alarm__list li a .list__info .time {
  font-weight: 400;
  font-size: 0.875rem;
  color: #6b7891;
}
.header__alarm .alarm__list li a .list__info .list__txt {
  display: flex;
  flex-direction: column;
  width: 65%;
}
.header__alarm .alarm__list li a .list__info .list__txt span {
  display: block;
  margin-bottom: 0.875rem;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 14px;
}
.header__alarm .alarm__list li a .list__info .list__txt span:last-child {
  margin-bottom: 0;
}
.header__alarm .alarm__list li a .list__info .list__txt span.tooltip-text {
  display: none;
  width: 100%;
  font-size: 12px;
  color: #2a2c2f;
  white-space: pre-wrap;
  margin: 0;
}
.header__alarm .alarm__list li a .list__info .list__txt span.tooltip:hover .tooltip-text {
  display: block;
}
.header__alarm .alarm__list li:hover a .list__name button:not(.readend) {
  border-color: #142c4c;
}
.header__alarm .alarm__list li:active a .list__name button:not(.readend) {
  border-color: #1f3e68;
}
.header__alarm .alarm__end {
  font-weight: 400;
  font-size: 13px;
  line-height: 14px;
  margin: 65px auto;
  text-align: center;
  width: 100%;
  color: #8898b7;
}
.header__menu {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex: 1;
}
.header__menu li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 80px;
  padding: 0 16px;
  height: 34px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1rem;
  text-align: center;
  letter-spacing: -0.4px;
  color: #fff;
}
.header__menu li.active a {
  background: #fff;
  color: #0978ff;
}

@media screen and (max-width: 1354px) {
  #wrap:not(.no-responsive) .header__etc li a.btn-admin span {
    display: none;
  }
  #wrap:not(.no-responsive) .header__logo {
    display: none;
  }
}
@media screen and (max-width: 1278px) {
  /* .header__etc li:last-child,
  .header__etc li:last-child .go-sei {
    margin-right: 0;
  } */
  .header__etc li a.btn-admin {
    width: auto;
  }
  .header__setting {
    right: 50px;
  }
  #wrap.page-market.community > header .header-etc-pop {
    top: 50px;
  }
}
@media screen and (max-width: 1202px) {
  .header__menu {
    gap: 0;
  }
}
@media screen and (max-width: 1106px) {
  #wrap:not(.no-responsive) .header__menu {
    display: none;
  }
}
@media screen and (max-width: 1100px) {
  .header__etc li:last-child .go-sei {
    display: none;
  }
  .header__setting {
    right: 0;
  }
  .header__etc li a.btn-admin {
    margin-right: 0;
  }
}
@media screen and (max-width: 679px) {
  .header__etc {
    margin: 0;
  }
}
@media screen and (max-width: 500px) {
  .header__etc li a.btn-set {
    display: none;
  }
  .header__setting {
    display: none;
  }
}

/* Nav */
.navbar {
  position: fixed;
  top: 3.125px;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0); */
  visibility: hidden;
  transition: visibility 0.5s;
  /* transition: visibility 0.5s, background-color 0.5s; */
  z-index: 110;
}
.navbar.active {
  /* background-color: rgba(0, 0, 0, 0.5); */
  visibility: visible;
}
.navbar.active .navbar__menu {
  left: 0;
}
.navbar__menu {
  position: fixed;
  top: 50px;
  left: -16.25rem;
  width: 16.25rem;
  height: calc(100% - 51px);
  background-color: #fff;
  transition: left 0.5s;
  overflow-y: auto;
  box-shadow: 0 0.125rem 0.5rem rgba(144, 159, 183, 0.8);
}
.navbar__menu li {
  padding: 0 1rem;
}
.navbar__menu li > a {
  display: flex;
  align-items: center;
  padding: 1.188rem 0 1.313rem 0.25rem;
  border-top: 1px solid #dde2e9;
  font-size: 1rem;
  font-weight: 500;
  color: #646c74;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat 98% center;
  background-size: 1.5rem 1.5rem;
}
.navbar__menu li.active > a {
  font-weight: 700;
  color: #0a78ff;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 98% center;
  background-size: 1.5rem 1.5rem;
}
/* .navbar__menu:not(.nook-user) li:first-child > a,
.navbar__menu:not(.nook-user) li:first-child.active > a {
  background: none;
} */

.navbar__menu li.btn-area:before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  border-top: 1px solid #dde2e9;
}
.navbar__menu li.btn-area .btn-basic {
  margin-top: 60px;
  width: 100%;
}
.navbar__menu li.btn-area .btn-basic span.icon-go:after {
  content: "";
  width: 24px;
  height: 24px;
  margin-left: 8px;
  margin-right: -8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center center;
  background-size: 100%;
}
.navbar__menu li.btn-area .btn-basic span {
  font-size: 14px !important;
  letter-spacing: -0.4px;
}
.navbar__menu li > ul {
  display: none;
}
.navbar__menu li.active > ul {
  display: block;
  padding-bottom: 18px;
}
.navbar__menu li ul li {
  padding: 0.625rem 0.625rem 0.75rem;
  margin: 0.125rem 0;
  border: 0;
}
.navbar__menu li ul li a {
  font-size: 0.875rem;
  color: #646c74;
  padding: 0;
  background: none;
  cursor: pointer;
  border-top: 0;
}
.navbar__menu li ul li a::before {
  content: "";
  width: 0.25rem;
  height: 0.25rem;
  margin-right: 0.5rem;
  border-radius: 50%;
  background: #646c74;
}
.navbar__menu li.active ul li.active {
  background: #b4d2ff;
  border-radius: 4px;
}
.navbar__menu li.active ul li.active a {
  font-size: 0.875rem;
  font-weight: 500;
  color: #0a78ff;
  background: none;
}
.navbar__menu li.active ul li.active a::before {
  background: #0a78ff;
}
.navbar__menu li.active ul li:hover {
  background: #e6f0ff;
  border-radius: 4px;
}
.navbar__menu li.active ul li:hover a {
  /* font-weight: 700; */
  /* color: #0A78FF; */
}
.navbar__menu li.active ul li:hover a::before {
  /* background: #0a78ff; */
}

/* container */
.container {
  min-height: calc(100vh - 4.125rem);
  display: flex;
  margin: 3.625rem 0.5rem 0.5rem 0.5rem;
}
.container.no-responsive {
  min-width: 1280px;
  overflow-x: auto;
}
.container.no-responsive::-webkit-scrollbar {
  height: 10px;
}
.container.admin-site {
  /* min-height: calc(100vh - 4.125rem); */
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive, .float-page) .container {
    margin: 3.625rem 0 0 0;
  }
}
@media screen and (max-width: 499px) {
  #wrap:not(.no-responsive, .float-page) .container {
    margin-top: 100px;
  }
}

/* content */
.content {
  display: flex;
  gap: 0.5rem;
  width: calc(100% - 282px);
  padding-left: 0.5rem;
}

@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive, .float-page) .content {
    width: 100%;
    padding-left: 0;
    margin-top: 44px;
  }
}

/* 컨텐츠 개별 box */
.box {
  background: #fff;
  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);
  border-radius: 4px;
  position: relative;
  overflow-x: hidden;
}
.box__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: auto;
  padding: 32px 24px 24px;
  border-bottom: 1px solid #dde2e9;
}
.box__header .select {
  width: auto;
  height: auto;
  font-weight: 700;
  font-size: 20px;
  line-height: 1;
  letter-spacing: -1px;
  border: 0;
  border-radius: 0;
}
.box__header .select .selected {
  padding: 0;
}
.box__header .select .selected .arrow {
  margin-left: 4px;
  width: 1.25rem;
  height: 1.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center center;
  background-size: 1.25rem 1.25rem;
}
.box__header .select.active .selected .arrow {
  transform: rotate(180deg);
}
.box__header .select ul {
  margin-top: 8px;
  width: 214px !important;
}
.box__header .select ul li {
  font-weight: 400;
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: #2a2c2f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 15px 24px;
  width: calc(100% - 48px) !important;
  border-bottom: 1px solid #dde2e9;
}
.box__header .select ul li:last-child {
  border-bottom: 0;
}
.box__header .select ul li:active {
  font-weight: 700;
  color: #0a78ff;
}

.box__title {
  font-weight: 700;
  font-size: 20px;
  line-height: 1;
  letter-spacing: -0.4px;
  color: #2a2c2f;
}
.box__body {
  position: relative;
  padding: 24px;
}
.box__search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.box__search input[type="text"] {
  width: 100%;
  border: 0;
  font-weight: 700;
  padding: 1px 38px 1px 16px;
  border: 1px solid;
  border-color: #909fb7 transparent;
  border-radius: 0;
}
.box__search input[type="text"]:focus {
  border: 1px solid #0a78ff !important;
}
.box__search .btn-search {
  position: absolute;
  right: 12px;
  width: 1.5rem;
  height: 1.5rem;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
  background-size: 100%;
}
.input__area .box__search {
  width: 100%;
}
/* 삭제 버튼 함께 들어갈 때 */
.treebar.box .box__search.input__direct input[type="text"] {
  padding-right: 58px;
  width: calc(100% - 74px);
}
.treebar.box .box__search.input__direct .btn-delete {
  right: 35px;
  width: 24px;
}
/*라인 모두 들어간 타입*/
.box__search.type-line {
  margin: 12px 7px 0 8px;
}
.treebar.box .box__search.type-line input[type="text"] {
  border: 1px solid #909fb7;
  border-radius: 4px;
  padding-right: 58px;
  width: calc(100% - 74px);
}
.treebar.box .box__search.type-line .btn-delete {
  position: absolute;
  top: 0;
  right: 35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center center;
  background-size: 14px 14px;
  width: 24px;
  height: 100%;
  margin-left: 0;
  z-index: 2;
}

/*포커스 갈때 디자인 변경*/
.box__search.focus {
  border: 1px solid #909fb7;
  border-left: 0;
  border-right: 0;
}
.box__search .focus__search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 91px);
  border-right: 1px solid #909fb7;
}
.box__search .focus__search input[type="text"] {
  padding-right: 0;
  border: 0;
  width: calc(100% - 50px);
}
.box__search .focus__search input[type="text"]:focus {
  outline: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  border: 0 !important;
}
.box__search .focus__search span {
  width: 50px;
  text-align: right;
  font-size: 14px;
  color: #909fb7;
  padding-right: 8px;
}
.box__search .focus__btn {
  display: flex;
  align-items: center;
  margin-right: 14px;
  margin-left: 8px;
}
.box__search .focus__btn button {
  border: 0;
  width: 20px;
  height: 20px;
  background-size: 100%;
}
.box__search .focus__btn .arrow-up {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center center;
}
.box__search .focus__btn .arrow-down {
  width: 20px;
  height: 20px;
  transform: rotate(180deg);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center center;
}
.box__search .focus__btn .close {
  margin-left: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center center;
}

@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive) .box {
    box-shadow: none;
    border-radius: 0;
  }
  #wrap:not(.no-responsive) .box__header.flex-column.brd-bottom-0.pb-0 {
    padding: 9px 0 0;
  }
}

/* treebar */
.treebar.box {
  width: 280px;
  /* min-height: 1006px; */
  min-height: 1013px;
  height: calc(100vh - 66px);
  border: 0;
  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);
}
.treebar.box .box__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2.938rem;
  padding: 0 0.75rem 0 1rem;
  border: 0;
}
.treebar.box .box__header .box__title {
  font-size: 16px;
}
.treebar.box .box__search input[type="text"] {
  border-left: 0;
  border-right: 0;
}
.treebar.box .box__search input[type="text"]::placeholder {
  opacity: 0.5;
}
.treebar.box .box__search input[type="text"]:-ms-input-placeholder {
  opacity: 0.5;
}
.treearea {
  overflow-y: auto;
  height: calc(100% - 81px);
  /* height: 920px; */
}
.tree__title {
  font-size: 14px;
  font-weight: 700;
  color: #2a2c2f;
  background: #f0f2f4;
  padding: 13px 16px;
}
.tree__title .highlight {
  display: flex;
  background: #e6f0ff;
  border-radius: 4px;
  color: #0a78ff;
  padding: 8px;
  margin: -8px;
}
.treearea .tree {
  padding: 1.125rem 1.5rem 2.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: #2a2c2f;
}
.treearea .tree ul {
  margin-top: 1.125rem;
}
.treearea .tree ul li {
  position: relative;
}
.treearea .tree ul.tree__depth2 li:first-child:before {
  content: "";
  position: absolute;
  top: 6px;
  left: -14px;
  background-color: #e9edef;
  width: 14px;
  height: 1px;
}
.treearea .tree ul.tree__depth2 li::before {
  content: "";
  position: absolute;
  top: 26px;
  left: -14px;
  background-color: #e9edef;
  width: 14px;
  height: 1px;
}
.treearea .tree ul.tree__depth2 li:after {
  content: "";
  position: absolute;
  top: -20px;
  left: -15px;
  background-color: #e9edef;
  width: 1px;
  height: calc(100% + 46px);
}
.treearea .tree ul.tree__depth2 li:last-child::after {
  content: "";
  position: absolute;
  top: -20px;
  left: -15px;
  background-color: #e9edef;
  width: 1px;
  height: 26px;
}
.treearea .tree ul.tree__depth3 li:first-child:before {
  content: "";
  position: absolute;
  top: 6px;
  left: -14px;
  background-color: #e9edef;
  width: 14px;
  height: 1px;
}
.treearea .tree ul.tree__depth3 li::before {
  content: "";
  position: absolute;
  top: 26px;
  left: -14px;
  background-color: #e9edef;
  width: 14px;
  height: 1px;
}
.treearea .tree ul.tree__depth3 li:after {
  content: "";
  position: absolute;
  top: -20px;
  left: -15px;
  background-color: #e9edef;
  width: 1px;
  height: calc(100% + 47px);
}
.treearea .tree ul.tree__depth3 li:last-child::after {
  content: "";
  position: absolute;
  top: -20px;
  left: -15px;
  background-color: #e9edef;
  width: 1px;
  height: 26px;
}
.tree__depth4::before {
  content: "";
  position: absolute;
  /* top: 20px; */
  top: 40px;
  left: 24px;
  background-color: #e9edef;
  width: 1px;
  height: calc(100% - 46px);
  /* height: calc(100% - 27px); */
}
.treearea .tree ul.tree__depth3 li:first-child .tree__depth4:before {
  content: "";
  position: absolute;
  top: 19px;
  left: 24px;
  background-color: #e9edef;
  width: 1px;
  height: calc(100% - 26px);
}
.treearea .tree ul.tree__depth4 li {
  padding-left: 42px;
}
.treearea .tree ul.tree__depth4 li:first-child:before {
  content: "";
  position: absolute;
  top: 7px;
  left: 5px;
  background-color: #e9edef;
  width: 14px;
  height: 1px;
}
.treearea .tree ul.tree__depth4 li::before {
  content: "";
  position: absolute;
  top: 27px;
  left: 5px;
  background-color: #e9edef;
  width: 14px;
  height: 1px;
}
.treearea .tree ul.tree__depth4 li:after {
  content: none;
}
.treearea .tree ul.tree__depth4 li:last-child::after {
  content: none;
}
.tree__depth4.container {
  content: "";
  position: absolute;
  top: 45px;
  left: 24px;
  background-color: #e9edef;
  width: 1px;
  height: calc(100% - 52px);
}
.treearea .tree ul.tree__depth4 li label {
  margin-left: -42px;
}
.treearea .tree ul li::before .treearea .tree ul li:last-child:before {
  content: none;
}
.treearea .tree ul.tree__depth6 li::before {
  content: none;
}
.treearea .tree li {
  position: relative;
  /* background: url("../img/treeview-line.gif") 5px 8px no-repeat; */
}
.treearea .tree li:last-child::before {
  height: 0;
}
.treearea .tree li + li {
  padding-top: 1.25rem;
}
.treearea .tree strong {
  margin-left: 0.563rem;
  padding-left: 1.125rem;
  font-weight: 400;
}
.treearea .tree a.on span {
  color: #0a78ff;
  font-weight: 500;
  position: relative;
  z-index: 2;
}
.treearea .tree a.highlight span {
  color: #0a78ff;
  font-weight: 500;
  position: relative;
  z-index: 2;
}
.treearea .tree li a.highlight::after {
  content: "";
  position: absolute;
  left: 15px;
  width: 100%;
  height: 32px;
  background: #e6f0ff;
  border-radius: 4px;
  z-index: 1;
}
.treearea .tree li:first-child a.highlight::after {
  top: -9px;
}
.treearea .tree li:not(:first-child) a.highlight::after {
  top: 11px;
}
.treearea .tree li ul.tree__depth2 li:first-child a.highlight::after {
  top: -9px;
}
.treearea .tree li ul.tree__depth2 li:not(:first-child) a.highlight::after {
  top: 11px;
}
.treearea .tree li ul.tree__depth3 li:first-child a.highlight::after {
  top: -9px;
}
.treearea .tree li ul.tree__depth3 li:not(:first-child) a.highlight::after {
  top: 11px;
}
.treearea .tree li ul.tree__depth4 li:first-child a.highlight::after {
  top: -9px;
}
.treearea .tree li ul.tree__depth4 li:not(:first-child) a.highlight::after {
  top: 11px;
}

.tree > li.tree__depth1 span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) 0 center no-repeat;
  background-size: 0.625rem 0.875rem;
}
.tree .tree__depth2 li span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) 0 center no-repeat;
  background-size: 0.563rem 0.875rem;
}
.tree .tree__depth3 li span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) 0 center no-repeat;
  background-size: 0.625rem 0.75rem;
}
.tree .tree__depth4 li span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) 0 center no-repeat;
  background-size: 0.625rem 0.75rem;
}
.tree > li.tree__depth1 a.on span,
.tree > li.tree__depth1 a.highlight span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) 0 center no-repeat;
  background-size: 0.625rem 0.875rem;
}
.tree .tree__depth2 li a.on span,
.tree .tree__depth2 li a.highlight span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) 0 center no-repeat;
  background-size: 0.563rem 0.875rem;
}
.tree .tree__depth3 li a.on span,
.tree .tree__depth3 li a.highlight span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) 0 center no-repeat;
  background-size: 0.625rem 0.75rem;
}
.tree .tree__depth4 li a.on span,
.tree .tree__depth4 li a.highlight span {
  padding-left: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) 0 center no-repeat;
  background-size: 0.625rem 0.75rem;
}
.treebar.box.close {
  width: 40px !important;
}
.treebar.close .box__title,
.treebar.close .box__search,
.treebar.close .treearea {
  display: none;
}
.treebar.close .box__header {
  padding: 0 0.75rem;
  justify-content: center;
  border-bottom: 0;
}
.treebar.close .btn-tree {
  position: relative;
  display: flex;
  width: auto;
  height: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat center center;
}
.treebar.close .btn-tree::after {
  content: "Beyond X™ Enable";
  writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  margin-top: 12.5rem;
  font-weight: 700;
}
.container.type2 .treebar.close .btn-tree::after {
  content: "Beyond X™ Enable";
}
.container.type2 .treebar.close .btn-tree::before {
  content: "™";
  transform: rotate(90deg);
  position: absolute;
  background: #fff;
  width: 16px;
  height: 20px;
  bottom: 60px;
  font-size: 0.875rem;
  color: #2a2c2f;
  font-weight: 700;
}
.treebar__toggleBtn,
.select__toggleBtn {
  display: none;
}
.tree ul {
  list-style: none;
  padding-left: 1.25rem;
}
.tree ul.tree__depth6 {
  padding-left: 1.95rem;
}
.tree label {
  cursor: pointer;
  font-size: 0.875rem;
  color: #2a2c2f;
}
.tree label:hover {
  color: #0a78ff;
}
.tree label:before {
  content: "";
  width: 0.688rem;
  height: 0.688rem;
  padding-right: 7px;
  display: inline-block;
  /* margin-left: -1.563rem;
  margin-right: 1.75rem; */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat 0 center;
  background-size: 0.688rem 0.688rem;
}
.tree .tree__depth5 label:before,
.tree .tree__depth6 label:before {
  padding-right: 0.75rem;
}
.tree ul.tree__depth6 li {
  background-position: 0px 0px;
  padding-left: 1.25rem;
  padding-top: 1.438rem;
  margin-top: -0.438rem;
  margin-left: -1.625rem;
}
.tree ul.tree__depth6 li:first-child {
  margin-top: -1.5rem;
}
.tree label.lastTree:before {
  background: none;
  padding-right: 14px;
}
.tree input[type="checkbox"]:checked + a label.lastTree:before {
  background: none;
}
.tree input[type="checkbox"]:checked + a label.lastTree:hover:before {
  background: none;
}
.tree label:hover:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat 0 center;
}
.tree .tree__depth4 label:hover:before {
  background: none;
}
.tree input[type="checkbox"] {
  display: none;
}
.tree input[type="checkbox"]:checked ~ ul {
  display: none;
}
.tree input[type="checkbox"]:checked + a label:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat 0 center;
  background-size: 0.688rem 0.688rem;
}
.tree input[type="checkbox"]:checked + a label:hover:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat 0 center;
}

@media screen and (max-width: 1280px) {
  .treebar.box {
    height: auto;
  }
}
@media screen and (max-width: 940px) {
  .treebar.box {
    display: none;
  }
  .treebar.box.active {
    display: block;
    position: fixed;
    top: 101px;
    width: 100% !important;
    border: 0;
    padding: 0;
    margin: 0;
    z-index: 100;
    box-shadow: none;
  }
  .treebar.box .box__header {
    display: none;
  }
  .treearea {
    height: calc(100vh - 146px);
  }
  .treebar__toggleBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 50px;
    left: 0;
    padding: 0 20px;
    width: calc(100% - 40px);
    height: 51px;
    background: #fff;
    border-bottom: 1px solid #dde2e9;
    z-index: 20;
    cursor: pointer;
  }
  .select__toggleBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 102px;
    left: 0;
    padding: 0 20px;
    width: calc(100% - 40px);
    height: 51px;
    background: #fff;
    border-bottom: 1px solid #dde2e9;
    z-index: 20;
    cursor: pointer;
  }
  .treebar__toggleBtn p,
  .select__toggleBtn p {
    display: block;
    width: calc(100% - 64px);
    font-weight: 700;
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: -0.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .treebar__toggleBtn:after,
  .select__toggleBtn::after {
    content: "";
    width: 24px;
    height: 24px;
    margin-left: 40px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center center;
    background-size: 100%;
  }
  .treebar__toggleBtn.active:after,
  .select__toggleBtn.active:after {
    content: "";
    transform: rotate(180deg);
  }
  .treebar .box__search input[type="text"] {
    height: 40px;
    border-color: #dde2e9;
  }
}
@media screen and (max-width: 499px) {
  .treebar__toggleBtn {
    top: 100px;
  }
  .select__toggleBtn {
    top: 152px;
  }
  .treebar.box.active {
    top: 151px;
  }
  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype.active {
    top: 152px;
  }
  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {
    top: 194px;
  }
}

/********************************************** For small screen, 반응형 **********************************************/

@media screen and (min-width: 500px) and (max-width: 768px) {
  header {
    height: 50px;
  }
  .container {
    min-height: calc(100vh - 59px);
    margin-top: 58px;
  }
}
@media screen and (max-width: 768px) {
  .header__userinfo {
    top: 50px;
  }
}
@media screen and (max-width: 499px) {
  header {
    padding-top: 50px;
    justify-content: flex-end;
  }
  .header__title,
  .header__title.beyoundx {
    background: none;
    width: calc(100% - 48px);
    padding: 0;
    margin: 0;
    font-size: 20px;
  }
  .header__right {
    margin-right: 10px;
  }
  .header__left {
    flex: 1;
  }
  header h1 {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    height: auto;
  }
  header:has(.header__title.beyoundx) h1 {
    width: calc(100% - 48px);
    font-weight: 500;
  }
  .header__userinfo {
    top: 100px;
    right: 0;
  }
  .header__userinfo li {
    padding: 15px 0 16px;
  }
  .header__alarm {
    width: 100%;
    height: calc(100vh - 100px);
    top: 100px;
  }
  /* .header__alarm .alarm__list {
    max-height: calc(100vh - 147px);
  } */
  .navbar {
    top: 6.25rem;
  }
  .navbar__menu {
    left: -100%;
    width: 100%;
    top: 6.25rem;
    height: calc(100% - 6rem);
  }
  .navbar__toggleBtn {
    width: 36px;
    height: 36px;
    margin-left: 12px;
  }
}
@media screen and (max-width: 499px) {
  .header__userinfo {
    top: 90px;
  }
  .header__alarm {
    top: 90px;
    height: calc(100vh - 90px);
  }
  .menu-slide {
    top: 146px;
    height: calc(100vh - 162px);
  }
  /* .header__alarm .alarm__list {
    max-height: calc(100vh - 133px);
  } */
}
@media screen and (max-width: 414px) {
  .navbar {
    top: 100px;
  }
  .navbar__menu {
    top: 100px;
    height: calc(100% - 100px);
  }
}
@media screen and (max-width: 360px) {
  header h1 {
    padding-left: 5px;
  }
}
@media screen and (max-width: 320px) {
  input[type="checkbox"] + label {
    font-size: 0.875rem;
    padding-left: 1.438rem;
  }
  input[type="checkbox"] + label:before {
    width: 1.125rem;
    height: 1.125rem;
    top: -2px;
  }
  /* input[type="checkbox"]:checked + label:after {
    top: -2px;
  } */
  .header__right {
    margin-right: 0.5rem;
  }
}

/* footer */
#wrap > footer {
  background: #26282e;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
#wrap > footer .footer-wrap {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 180px;
  width: 100%;
  max-width: 1230px;
  padding: 20px 0 40px;
}
#wrap > footer .footer-wrap .top,
#wrap > footer .footer-wrap .bottom {
  display: flex;
  justify-content: space-between;
}
#wrap > footer h1 {
  width: 148px;
  height: 20px;
}
#wrap > footer h1 > img {
  width: auto;
  height: 100%;
}
.familysite {
  position: relative;
  width: 168px;
  height: 36px;
  background: #26282e;
}
.familysite a.tit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 16px);
  height: 100%;
  padding: 0 8px;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #dde2e9;
}
.familysite a:after {
  content: "";
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) no-repeat right center;
  background-size: 100%;
}
.familysite .sitelist {
  display: none;
  position: absolute;
  left: 0;
  top: 36px;
  z-index: 1;
  width: 100%;
  max-height: 144px;
  overflow-y: auto;
  background: #41444a;
}
.familysite .sitelist::-webkit-scrollbar-thumb {
  background-color: #34363c;
}
.familysite .sitelist a {
  display: block;
  padding: 10px 8px;
  height: 100%;
  font-size: 12px;
  letter-spacing: -0.04em;
  line-height: 1.33;
  color: #dde2e9;
}
.familysite .sitelist li:hover a {
  background: #34363c;
}
.familysite .sitelist li:active a {
  background: #26282e;
}
.familysite.active .sitelist {
  display: block;
}
.familysite.active a:after {
  transform: rotate(180deg);
}
.familysite.active {
  background: #41444a;
}

#wrap > footer .footer-wrap .top .right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
#wrap > footer .footer-wrap .top .right .btn-txt {
  font-size: 13px;
  line-height: 2.15;
  letter-spacing: -0.01em;
  color: #dde2e9;
}
#wrap > footer .footer-wrap .top .right .btn-txt strong {
  font-weight: 500;
}
#wrap > footer .footer-wrap .bottom {
  align-items: flex-end;
}
#wrap > footer .footer-wrap .bottom ul {
  margin-top: 16px;
}
#wrap > footer .footer-wrap .bottom ul > li {
  font-size: 12px;
  line-height: 1.7;
  letter-spacing: -0.04em;
  color: #909fb7;
}
#wrap > footer .footer-wrap .bottom ul > li a {
  font-weight: 500;
}
.copy {
  font-size: 11px;
  color: #909fb7;
  font-weight: 350;
  line-height: 1.7;
  letter-spacing: -0.02em;
}
#wrap > footer .footer-wrap .copy strong {
  font-weight: 500;
}

@media screen and (max-width: 1278px) {
  #wrap > footer {
    padding: 0 40px;
    width: calc(100% - 80px);
  }
}
@media screen and (max-width: 820px) {
  #wrap > footer .footer-wrap .bottom {
    align-items: flex-start;
    flex-direction: column;
    margin-top: 20px;
  }
  #wrap > footer .footer-wrap .bottom .left,
  #wrap > footer .footer-wrap .bottom .right {
    width: 100%;
  }
  #wrap > footer .footer-wrap .bottom .right {
    margin-top: 16px;
    text-align: right;
  }
}
@media screen and (max-width: 499px) {
  #wrap > footer {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
}
@media screen and (max-width: 350px) {
  #wrap > footer .footer-wrap .top {
    align-items: flex-start;
    flex-direction: column;
  }
  #wrap > footer .footer-wrap .top .right {
    width: 100%;
    text-align: right;
    margin-top: 10px;
  }
}
.foot-btn {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.foot-btn .btn-txt {
  font-size: 13px;
  line-height: 2.15;
  letter-spacing: -0.01em;
  color: #7783a1;
}
.foot-btn .btn-txt:hover,
.foot-btn .btn-txt:active {
  font-weight: 500;
}

/* ck 에디터 관련 */
.ck.ck-editor,
.ck.ck-reset.ck-editor {
  height: 100% !important;
}
.ck.ck-editor__main {
  height: calc(100% - 31px) !important;
  border-top: 1px solid #dde2e9 !important;
}
.ck.ck-editor__main .ck.ck-content.ck-editor__editable {
  height: calc(100% - 16px) !important;
  padding: 16px 24px 0 !important;
  border: 0 !important;
  border-radius: 0 0 4px 4px !important;
  box-shadow: none !important;
}
.ck.ck-editor__main h2 {
  font-size: 1.5em !important;
}
.ck.ck-editor__main h3 {
  font-size: 1.17em !important;
}
.ck.ck-editor__main h2,
.ck.ck-editor__main h3,
.ck.ck-editor__main h4 {
  font-weight: bold !important;
  padding: 0 !important;
  margin: 0 !important;
  /* margin: revert;
  padding: revert; */
}
.ck.ck-editor__main h4,
.ck.ck-editor__main p,
.ck.ck-editor__main span {
  font-size: 1em !important;
  padding: 0 !important;
  margin: 0 !important;
}
.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {
  box-shadow: none !important;
}
.ck.ck-toolbar {
  border: 0 !important;
  height: 30px !important;
}
.ck.ck-toolbar.ck-toolbar_vertical {
  height: auto !important;
  width: auto !important;
}
.ck.ck-toolbar > .ck-toolbar__items {
  height: auto !important;
}
.ck i {
  display: unset !important;
  width: unset !important;
  height: unset !important;
}
.ck dl,
.ck ol,
.ck table,
.ck ul,
.ck p,
.ck span {
  margin: revert;
  padding: revert;
}
.ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items > .ck {
  width: auto !important;
}
.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item {
  margin: 0 !important;
}
.ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items > .ck {
  width: auto !important;
}
.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,
.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
  right: 0 !important;
  left: unset !important;
}
.ck.ck-list-styles-list {
  padding: 0 !important;
}
.ck.ck-toolbar-dropdown > .ck-dropdown__panel {
  max-width: unset !important;
}
.ck.ck-toolbar > .ck-toolbar__items > :not(.ck-toolbar__line-break),
.ck.ck-toolbar > .ck.ck-toolbar__grouped-dropdown {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.ck.ck-toolbar > .ck-toolbar__items > :not(.ck-toolbar__line-break) {
  margin-right: 0;
}
@media screen and (max-width: 499px) {
  .ck.ck-toolbar-dropdown > .ck-dropdown__panel {
    max-width: var(--ck-toolbar-dropdown-max-width) !important;
  }
  .write-area .editarea .editbox-wrap .ck.ck-toolbar {
    height: auto !important;
  }
}
@media screen and (max-width: 400px) {
  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,
  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
    left: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./static/css/style.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAShB,kGAAkG;AAClG;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,2EAA8D;EAC9D,qBAAqB;AACvB;AACA,aAAa;AACb;EACE,eAAe;EACf,YAAY;EACZ,2EAA6E;EAC7E,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,OAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,2EAA+D;EAC/D,gCAAgC;AAClC;AACA;EACE,mFAAuE;EACvE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,OAAO;AACT;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;;;;;GAKG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;AACA;EACE,2EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,2EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,2EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,sEAAgE;EAChE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2EAAwE;EACxE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,4CAA4C;EAC5C,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,UAAU,EAAE,cAAc;EAC1B,WAAW;EACX,gBAAgB;EAChB,qDAAqD;EACrD,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,OAAO;EACP,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,sBAAsB,EAAE,cAAc;EACtC,QAAQ,EAAE,cAAc;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2EAA0E;EAC1E,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;;EAEE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;;;;;;EAME,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,2EAA8D;AAChE;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;;;KAGG;EACH;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,MAAM;EACR;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,2BAA2B;EAC3B,wDAAwD;EACxD,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,sDAAsD;AACxD;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yEAA6D;EAC7D,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yEAA6D;EAC7D,8BAA8B;AAChC;AACA;;;GAGG;;AAEH;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,4EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,kCAAkC;EAClC,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,wCAAwC;AAC1C;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4EAAmE;EACnE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,SAAS;EACT,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA,eAAe;AACf;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,4EAA0E;EAC1E,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAqE;AACvE;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4EAAqE;AACvE;AACA;EACE,gBAAgB;EAChB,4EAAqE;AACvE;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mEAAmE;AACrE;AACA;EACE,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uEAA8D;EAC9D,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,uEAA8D;EAC9D,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,uEAA8D;EAC9D,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,uEAA8D;EAC9D,iCAAiC;AACnC;AACA;;EAEE,kBAAkB;EAClB,uEAAiE;EACjE,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;EAClB,uEAAiE;EACjE,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;EAClB,uEAAiE;EACjE,iCAAiC;AACnC;AACA;;EAEE,kBAAkB;EAClB,uEAAiE;EACjE,iCAAiC;AACnC;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,4EAAmE;AACrE;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB;0BACwB;EACxB,uEAA4D;EAC5D,kCAAkC;AACpC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,uEAA4D;AAC9D;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,uEAA4D;EAC5D,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,uEAA4D;AAC9D;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,SAAS;IACT,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,OAAO;IACP,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,OAAO;IACP,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,eAAe;EACjB;EACA;;IAEE,cAAc;IACd,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;;IAEE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4EAAmE;IACnE,qBAAqB;EACvB;EACA;;IAEE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oHAAoH;;AAEpH;EACE;IACE,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;;IAEE,gBAAgB;IAChB,wBAAwB;IACxB,UAAU;IACV,SAAS;IACT,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,2BAA2B;IAC3B,UAAU;EACZ;EACA;;KAEG;EACH;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,SAAS;IACT,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;;KAEG;AACL;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;EACA;;KAEG;EACH;IACE,oBAAoB;EACtB;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;EAClB;EACA;;IAEE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;;AAEA,cAAc;AACd;;EAEE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB;oBACkB;AACpB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;;;;;;EAME,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,0DAA0D;EAC5D;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":["@charset \"UTF-8\";\r\n@import url(font.css);\r\n@import url(reset.css);\r\n@import url(common.css);\r\n@import url(content.css);\r\n@import url(community.css);\r\n@import url(login.css);\r\n@import url(download.css);\r\n\r\n/********************************************** sub **********************************************/\r\n#wrap {\r\n  position: absolute;\r\n  width: 100%;\r\n  min-width: 19.938rem;\r\n  min-height: 100%;\r\n  background-color: #fff;\r\n  overflow-x: hidden;\r\n}\r\n#wrap:not(.email, .randing, .intro, .page-market) {\r\n  background-color: #e9edef;\r\n}\r\n\r\n/* header */\r\nheader {\r\n  background-color: #0a78ff;\r\n  position: fixed;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  height: 50px;\r\n  /* z-index: 21; */\r\n  z-index: 11;\r\n}\r\n/* sei - 마켓플레이스 */\r\n#wrap.page-market > header {\r\n  background-color: #fff;\r\n  height: 62px;\r\n  border-bottom: 1px solid #dde2e9;\r\n}\r\nheader h1 {\r\n  width: 237.6px;\r\n  height: 100%;\r\n  margin-left: 4px;\r\n  font-size: 1.25rem;\r\n  font-weight: 900;\r\n  color: #fff;\r\n}\r\n.header__title {\r\n  font-size: 0;\r\n  background: url(\"../img/img_logo.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n/* beyoundx */\r\n.header__title.beyoundx {\r\n  width: 192.22px;\r\n  height: 26px;\r\n  background: url(\"../img/img_logo_beyoundX_white.svg\") no-repeat center center;\r\n  background-size: contain;\r\n}\r\n.header__left {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  height: 100%;\r\n  flex: 2;\r\n}\r\n.navbar__toggleBtn {\r\n  width: 50px;\r\n  height: 100%;\r\n  background: url(\"../img/icon_menu.png\") no-repeat center center;\r\n  background-size: 1.75rem 1.75rem;\r\n}\r\n.navbar__toggleBtn.active {\r\n  background: url(\"../img/icon_menu.png\") no-repeat center center #0050b8;\r\n  background-size: 1.75rem 1.75rem;\r\n}\r\n.header__right {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  height: 100%;\r\n  margin-right: 16px;\r\n}\r\nheader time {\r\n  font-size: 0.875rem;\r\n  color: #fff;\r\n}\r\n.header__etc {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  flex: 1;\r\n}\r\n.header__etc li {\r\n  width: auto;\r\n  height: 2.5rem;\r\n  text-align: center;\r\n  display: flex;\r\n  align-items: center;\r\n  /* margin-right: 15px; */\r\n}\r\n/* .header__etc li:last-child {\r\n  margin-right: 10px;\r\n}\r\n.header__etc li:last-child a.btn-admin {\r\n  margin-right: 5px;\r\n} */\r\n.header__etc li a {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  color: #fff;\r\n}\r\n.header__etc li a.btn-refresh {\r\n  background: url(\"../img/icon_refresh@3x.png\") no-repeat center center;\r\n  background-size: 36px;\r\n}\r\n.header__etc li a.btn-set {\r\n  position: relative;\r\n  width: 40px;\r\n  background: url(\"../img/icon_set@3x.png\") no-repeat center center;\r\n  background-size: 36px;\r\n}\r\n.header__etc li a.btn-alarm {\r\n  position: relative;\r\n  width: 40px;\r\n  background: url(\"../img/icon_alarm@3x.png\") no-repeat center center;\r\n  background-size: 36px;\r\n}\r\n.header__etc li a.btn-alarm p {\r\n  position: absolute;\r\n  top: 0.188rem;\r\n  left: 1.2rem;\r\n  padding: 0 3px 0 2px;\r\n  height: 0.938rem;\r\n  min-width: 10px;\r\n  background-color: #f55547;\r\n  border-radius: 45px;\r\n  color: #fff;\r\n  font-size: 0.625rem;\r\n  text-align: center;\r\n  line-height: 0.95rem;\r\n}\r\n.header__etc li a.btn-admin {\r\n  background: url(\"../img/icon_profile@3x.png\") no-repeat 0 center;\r\n  background-size: 2.25rem 2.25rem;\r\n}\r\n.header__etc li a.btn-admin span {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  margin-left: 38px;\r\n}\r\n.header__etc li .go-sei {\r\n  margin-right: 15px;\r\n}\r\n.header__etc li.active a {\r\n  background-color: #0050b8;\r\n  border-radius: 2px;\r\n}\r\n.header__etc li.active a.btn-admin {\r\n  background-color: transparent;\r\n}\r\n.header__logo {\r\n  margin-left: 24px;\r\n  width: 46px;\r\n  height: 22px;\r\n  background: url(\"../img/icon_logo_ls_white.svg\") no-repeat center center;\r\n  background-size: 100%;\r\n  opacity: 0.7;\r\n}\r\n.header__setting {\r\n  position: absolute;\r\n  top: 50px;\r\n  right: 160px;\r\n  width: auto;\r\n  padding: 16px;\r\n  background: #2a2c2f;\r\n  border: 1px solid #576274;\r\n  border-radius: 0 0 4px 4px;\r\n  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.5);\r\n  z-index: 3;\r\n}\r\n.header__setting.open {\r\n  display: block;\r\n}\r\n.header__setting li {\r\n  margin-bottom: 1.5rem;\r\n}\r\n.header__setting li:last-child {\r\n  margin-bottom: 0.25rem;\r\n}\r\n.header__setting li p {\r\n  font-weight: 500;\r\n  font-size: 0.937rem;\r\n  line-height: 0.875rem;\r\n  letter-spacing: -0.4px;\r\n  color: #ffffff;\r\n  margin-bottom: 0.875rem;\r\n}\r\n.header__setting li .setting__btn {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.header__setting li .setting__btn button {\r\n  width: 100%;\r\n  min-width: 78px;\r\n  padding: 0 10px;\r\n  height: 28px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 78px;\r\n  padding: 0 10px;\r\n  border: 0;\r\n  border-radius: 0;\r\n  background: #6b7891;\r\n}\r\n.header__setting li .setting__btn button:first-child {\r\n  border-radius: 4px 0 0 4px;\r\n}\r\n.header__setting li .setting__btn button:last-child {\r\n  border-radius: 0 4px 4px 0;\r\n}\r\n.header__setting li .setting__btn button span {\r\n  color: #fff;\r\n  font-weight: 400;\r\n  font-size: 0.875rem;\r\n  line-height: 1;\r\n}\r\n.header__setting li .setting__btn button.on {\r\n  background: #0a78ff;\r\n}\r\n.header__setting li .setting__btn button.on span {\r\n  font-weight: 700;\r\n}\r\n.header__userinfo {\r\n  position: absolute;\r\n  top: 50px;\r\n  right: 6px;\r\n  width: 14.65rem;\r\n  background: #2a2c2f;\r\n  border: 1px solid #576274;\r\n  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.5);\r\n  z-index: 4;\r\n}\r\n.header__userinfo li {\r\n  display: flex;\r\n  align-items: center;\r\n  height: auto;\r\n  padding: 12px 0 13px;\r\n  border-bottom: 1px solid #576274;\r\n}\r\n.header__userinfo li:last-child {\r\n  border-bottom: 0;\r\n}\r\n.header__userinfo li a {\r\n  display: flex;\r\n  align-items: center;\r\n  width: calc(100% - 32px);\r\n  height: 100%;\r\n  padding: 0 16px;\r\n  font-weight: 500;\r\n  font-size: 0.937rem;\r\n  line-height: 0.875rem;\r\n  letter-spacing: -0.025rem;\r\n  color: #ffffff;\r\n}\r\n.header-etc-pop {\r\n  display: none;\r\n}\r\n.header-etc-pop.active {\r\n  display: block;\r\n}\r\n.header-etc-pop,\r\n#wrap.page-market > header .header-etc-pop {\r\n  position: absolute;\r\n  top: 52px;\r\n  left: 84px; /* 241126 수정 */\r\n  width: 80px;\r\n  background: #fff;\r\n  box-shadow: 0px 4px 12px 0px rgba(122, 133, 150, 0.5);\r\n  border-radius: 4px;\r\n  z-index: 4;\r\n}\r\n#wrap.page-market .header-etc-pop.header__userinfo {\r\n  width: 152px;\r\n  left: 0;\r\n  border: 0;\r\n}\r\n#wrap.page-market .header__etc li {\r\n  position: relative;\r\n  gap: 16px;\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n#wrap.page-market .header__etc li:last-child {\r\n  margin-right: 0;\r\n}\r\n.header-etc-pop li {\r\n  display: flex;\r\n  align-items: center;\r\n  height: auto;\r\n}\r\n.header-etc-pop li a {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 12px 16px;\r\n  font-size: 14px;\r\n  line-height: 1.14;\r\n  letter-spacing: -0.02em;\r\n  color: #2a2c2f;\r\n}\r\n#wrap.page-market .header-etc-pop li:hover a,\r\n#wrap.page-market .header-etc-pop li:active a {\r\n  font-weight: 500;\r\n  color: #0a78ff;\r\n  letter-spacing: -0.03em;\r\n}\r\n.header__etc .btn-lang {\r\n  padding: 0 12px 0 12px; /* 241125 수정 */\r\n  gap: 6px; /* 241125 수정 */\r\n}\r\n.header__etc .btn-lang:after {\r\n  content: \"\";\r\n  width: 16px;\r\n  height: 16px;\r\n  background: url(\"../img/icon_arrow_secondary.svg\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.header__etc .btn-lang.active:after {\r\n  transform: scaleY(-1);\r\n}\r\n.btn-lang-nav {\r\n  display: none;\r\n}\r\n.navbar.active .btn-lang-nav,\r\n#wrap.page-market .navbar__menu li.btn-lang-nav {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  position: absolute;\r\n  bottom: 38px;\r\n  right: 0;\r\n  gap: 50px;\r\n  margin: 0 20px;\r\n  padding: 0 30px 0 0;\r\n  width: calc(100% - 40px);\r\n  border-top: 1px solid #dde2e9;\r\n}\r\n.navbar__menu li.btn-lang-nav > a,\r\n#wrap.page-market .navbar__menu li.btn-lang-nav > a {\r\n  padding: 0;\r\n  margin-top: 18px;\r\n  border: 0;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  color: #2a2c2f;\r\n  letter-spacing: -0.04em;\r\n}\r\n.navbar__menu li.btn-lang-nav > a:hover,\r\n.navbar__menu li.btn-lang-nav > a:active,\r\n.navbar__menu li.btn-lang-nav > a.on,\r\n#wrap.page-market .navbar__menu li.btn-lang-nav > a:hover,\r\n#wrap.page-market .navbar__menu li.btn-lang-nav > a:active,\r\n#wrap.page-market .navbar__menu li.btn-lang-nav > a.on {\r\n  font-weight: 500;\r\n  color: #0a78ff;\r\n}\r\n\r\n.header__alarm {\r\n  position: absolute;\r\n  top: 50px;\r\n  right: 0;\r\n  width: 28.937rem;\r\n  height: calc(100vh - 50px);\r\n  background: #2a2c2f;\r\n  border: 1px solid #576274;\r\n  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.5);\r\n  z-index: 5;\r\n  overflow-y: auto;\r\n}\r\n.header__alarm .nodata__txt {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  line-height: 14px;\r\n  text-align: center;\r\n  width: 100%;\r\n  height: 80%;\r\n  color: #8898b7;\r\n}\r\n.header__alarm .nodata__txt::before {\r\n  content: \"\";\r\n  margin-bottom: 16px;\r\n  width: 106px;\r\n  height: 100px;\r\n  background: url(\"../img/no_alarm.png\") no-repeat center center;\r\n}\r\n.header__alarm p,\r\n.header__alarm span {\r\n  color: #fff;\r\n}\r\n.header__alarm .alarm__top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 11px 16px;\r\n  border-bottom: 1px solid #646c74;\r\n}\r\n.header__alarm .alarm__top .title {\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n  color: #fff;\r\n}\r\n.header__alarm .alarm__top .title span {\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n  color: #909fb7;\r\n  margin-left: 1rem;\r\n}\r\n.header__alarm .alarm__top p {\r\n  font-size: 12px;\r\n  color: #0a78ff;\r\n}\r\n.header__alarm .alarm__top button {\r\n  border: 0;\r\n}\r\n.header__alarm .alarm__top button span {\r\n  font-weight: 400;\r\n  font-size: 0.75rem;\r\n  color: #0a78ff;\r\n}\r\n.header__alarm .alarm__top button:hover span {\r\n  color: #9ac1ff;\r\n}\r\n.header__alarm .alarm__top button:active span {\r\n  color: #fff;\r\n}\r\n.alarm__notice {\r\n  padding: 9px 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.alarm__notice p {\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  line-height: 16px;\r\n  letter-spacing: -0.4px;\r\n  color: #8898b7;\r\n  height: 18px;\r\n}\r\n.alarm__notice button.btn-alarmread {\r\n  padding: 3px 10px;\r\n  background: #3e4858;\r\n  border: 0;\r\n  border-radius: 10px;\r\n}\r\n.alarm__notice button.btn-alarmread span {\r\n  font-size: 12px;\r\n  letter-spacing: -0.4px;\r\n  color: #fff;\r\n  font-weight: 400;\r\n}\r\n.alarm__notice button.btn-alarmread:hover {\r\n  background: #6b7891;\r\n}\r\n.header__alarm .alarm__list li {\r\n  border-bottom: 1px solid #646c74;\r\n}\r\n.header__alarm .alarm__list li:hover {\r\n  background: #142c4c;\r\n}\r\n.header__alarm .alarm__list li:active {\r\n  background: #1f3e68;\r\n}\r\n.header__alarm .alarm__list li a {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 1rem;\r\n}\r\n.header__alarm .alarm__list li a .list__name {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 1rem;\r\n}\r\n.header__alarm .alarm__list li a .list__name button {\r\n  position: relative;\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 4px solid #2a2c2f;\r\n  background: #0a78ff;\r\n  border-radius: 50px;\r\n}\r\n.header__alarm .alarm__list li a .list__name button:hover::before {\r\n  content: \"읽음으로 표시\";\r\n  position: absolute;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  right: 22px;\r\n  width: 85px;\r\n  height: 18px;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  color: #2a2c2f;\r\n  background: #dde2e9;\r\n  border-radius: 10px;\r\n  z-index: 1000;\r\n}\r\n.header__alarm .alarm__list li a .list__name button:hover:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -5px;\r\n  top: -5px;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50px;\r\n  background: transparent;\r\n  border: 1px solid#0A78FF;\r\n}\r\n.header__alarm .alarm__list li a .list__name button.readend {\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 1px solid #515d6f;\r\n  background: transparent;\r\n}\r\n.header__alarm .alarm__list li a .list__name button.readend:hover:before {\r\n  content: \"읽지않음으로 표시\";\r\n  width: 108px;\r\n  right: 24px;\r\n}\r\n.header__alarm .alarm__list li a .list__name button.readend:hover:after {\r\n  content: none;\r\n}\r\n.header__alarm .alarm__list li a .list__name p {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  line-height: 0.875rem;\r\n  width: 95%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.header__alarm .alarm__list li a .list__name .num {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 400;\r\n  font-size: 0.75rem;\r\n  color: #2a2c2f;\r\n  background: #dde2e9;\r\n  border-radius: 10px;\r\n  height: 15px;\r\n  width: auto;\r\n  padding: 2px 10px 1px;\r\n  margin-left: 24px;\r\n}\r\n.header__alarm .alarm__list li a .list__info {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n}\r\n.header__alarm .alarm__list li a .list__info .time {\r\n  font-weight: 400;\r\n  font-size: 0.875rem;\r\n  color: #6b7891;\r\n}\r\n.header__alarm .alarm__list li a .list__info .list__txt {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 65%;\r\n}\r\n.header__alarm .alarm__list li a .list__info .list__txt span {\r\n  display: block;\r\n  margin-bottom: 0.875rem;\r\n  width: 95%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n}\r\n.header__alarm .alarm__list li a .list__info .list__txt span:last-child {\r\n  margin-bottom: 0;\r\n}\r\n.header__alarm .alarm__list li a .list__info .list__txt span.tooltip-text {\r\n  display: none;\r\n  width: 100%;\r\n  font-size: 12px;\r\n  color: #2a2c2f;\r\n  white-space: pre-wrap;\r\n  margin: 0;\r\n}\r\n.header__alarm .alarm__list li a .list__info .list__txt span.tooltip:hover .tooltip-text {\r\n  display: block;\r\n}\r\n.header__alarm .alarm__list li:hover a .list__name button:not(.readend) {\r\n  border-color: #142c4c;\r\n}\r\n.header__alarm .alarm__list li:active a .list__name button:not(.readend) {\r\n  border-color: #1f3e68;\r\n}\r\n.header__alarm .alarm__end {\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  line-height: 14px;\r\n  margin: 65px auto;\r\n  text-align: center;\r\n  width: 100%;\r\n  color: #8898b7;\r\n}\r\n.header__menu {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 16px;\r\n  flex: 1;\r\n}\r\n.header__menu li a {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: auto;\r\n  min-width: 80px;\r\n  padding: 0 16px;\r\n  height: 34px;\r\n  border-radius: 4px;\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n  line-height: 1rem;\r\n  text-align: center;\r\n  letter-spacing: -0.4px;\r\n  color: #fff;\r\n}\r\n.header__menu li.active a {\r\n  background: #fff;\r\n  color: #0978ff;\r\n}\r\n\r\n@media screen and (max-width: 1354px) {\r\n  #wrap:not(.no-responsive) .header__etc li a.btn-admin span {\r\n    display: none;\r\n  }\r\n  #wrap:not(.no-responsive) .header__logo {\r\n    display: none;\r\n  }\r\n}\r\n@media screen and (max-width: 1278px) {\r\n  /* .header__etc li:last-child,\r\n  .header__etc li:last-child .go-sei {\r\n    margin-right: 0;\r\n  } */\r\n  .header__etc li a.btn-admin {\r\n    width: auto;\r\n  }\r\n  .header__setting {\r\n    right: 50px;\r\n  }\r\n  #wrap.page-market.community > header .header-etc-pop {\r\n    top: 50px;\r\n  }\r\n}\r\n@media screen and (max-width: 1202px) {\r\n  .header__menu {\r\n    gap: 0;\r\n  }\r\n}\r\n@media screen and (max-width: 1106px) {\r\n  #wrap:not(.no-responsive) .header__menu {\r\n    display: none;\r\n  }\r\n}\r\n@media screen and (max-width: 1100px) {\r\n  .header__etc li:last-child .go-sei {\r\n    display: none;\r\n  }\r\n  .header__setting {\r\n    right: 0;\r\n  }\r\n  .header__etc li a.btn-admin {\r\n    margin-right: 0;\r\n  }\r\n}\r\n@media screen and (max-width: 679px) {\r\n  .header__etc {\r\n    margin: 0;\r\n  }\r\n}\r\n@media screen and (max-width: 500px) {\r\n  .header__etc li a.btn-set {\r\n    display: none;\r\n  }\r\n  .header__setting {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Nav */\r\n.navbar {\r\n  position: fixed;\r\n  top: 3.125px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  /* background-color: rgba(0, 0, 0, 0); */\r\n  visibility: hidden;\r\n  transition: visibility 0.5s;\r\n  /* transition: visibility 0.5s, background-color 0.5s; */\r\n  z-index: 110;\r\n}\r\n.navbar.active {\r\n  /* background-color: rgba(0, 0, 0, 0.5); */\r\n  visibility: visible;\r\n}\r\n.navbar.active .navbar__menu {\r\n  left: 0;\r\n}\r\n.navbar__menu {\r\n  position: fixed;\r\n  top: 50px;\r\n  left: -16.25rem;\r\n  width: 16.25rem;\r\n  height: calc(100% - 51px);\r\n  background-color: #fff;\r\n  transition: left 0.5s;\r\n  overflow-y: auto;\r\n  box-shadow: 0 0.125rem 0.5rem rgba(144, 159, 183, 0.8);\r\n}\r\n.navbar__menu li {\r\n  padding: 0 1rem;\r\n}\r\n.navbar__menu li > a {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 1.188rem 0 1.313rem 0.25rem;\r\n  border-top: 1px solid #dde2e9;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  color: #646c74;\r\n  background: url(\"../img/icon_nav_d.png\") no-repeat 98% center;\r\n  background-size: 1.5rem 1.5rem;\r\n}\r\n.navbar__menu li.active > a {\r\n  font-weight: 700;\r\n  color: #0a78ff;\r\n  background: url(\"../img/icon_nav_u.png\") no-repeat 98% center;\r\n  background-size: 1.5rem 1.5rem;\r\n}\r\n/* .navbar__menu:not(.nook-user) li:first-child > a,\r\n.navbar__menu:not(.nook-user) li:first-child.active > a {\r\n  background: none;\r\n} */\r\n\r\n.navbar__menu li.btn-area:before {\r\n  content: \"\";\r\n  display: block;\r\n  width: 100%;\r\n  height: 1px;\r\n  border-top: 1px solid #dde2e9;\r\n}\r\n.navbar__menu li.btn-area .btn-basic {\r\n  margin-top: 60px;\r\n  width: 100%;\r\n}\r\n.navbar__menu li.btn-area .btn-basic span.icon-go:after {\r\n  content: \"\";\r\n  width: 24px;\r\n  height: 24px;\r\n  margin-left: 8px;\r\n  margin-right: -8px;\r\n  background: url(\"../img/icon_page_go.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.navbar__menu li.btn-area .btn-basic span {\r\n  font-size: 14px !important;\r\n  letter-spacing: -0.4px;\r\n}\r\n.navbar__menu li > ul {\r\n  display: none;\r\n}\r\n.navbar__menu li.active > ul {\r\n  display: block;\r\n  padding-bottom: 18px;\r\n}\r\n.navbar__menu li ul li {\r\n  padding: 0.625rem 0.625rem 0.75rem;\r\n  margin: 0.125rem 0;\r\n  border: 0;\r\n}\r\n.navbar__menu li ul li a {\r\n  font-size: 0.875rem;\r\n  color: #646c74;\r\n  padding: 0;\r\n  background: none;\r\n  cursor: pointer;\r\n  border-top: 0;\r\n}\r\n.navbar__menu li ul li a::before {\r\n  content: \"\";\r\n  width: 0.25rem;\r\n  height: 0.25rem;\r\n  margin-right: 0.5rem;\r\n  border-radius: 50%;\r\n  background: #646c74;\r\n}\r\n.navbar__menu li.active ul li.active {\r\n  background: #b4d2ff;\r\n  border-radius: 4px;\r\n}\r\n.navbar__menu li.active ul li.active a {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #0a78ff;\r\n  background: none;\r\n}\r\n.navbar__menu li.active ul li.active a::before {\r\n  background: #0a78ff;\r\n}\r\n.navbar__menu li.active ul li:hover {\r\n  background: #e6f0ff;\r\n  border-radius: 4px;\r\n}\r\n.navbar__menu li.active ul li:hover a {\r\n  /* font-weight: 700; */\r\n  /* color: #0A78FF; */\r\n}\r\n.navbar__menu li.active ul li:hover a::before {\r\n  /* background: #0a78ff; */\r\n}\r\n\r\n/* container */\r\n.container {\r\n  min-height: calc(100vh - 4.125rem);\r\n  display: flex;\r\n  margin: 3.625rem 0.5rem 0.5rem 0.5rem;\r\n}\r\n.container.no-responsive {\r\n  min-width: 1280px;\r\n  overflow-x: auto;\r\n}\r\n.container.no-responsive::-webkit-scrollbar {\r\n  height: 10px;\r\n}\r\n.container.admin-site {\r\n  /* min-height: calc(100vh - 4.125rem); */\r\n}\r\n@media screen and (max-width: 940px) {\r\n  #wrap:not(.no-responsive, .float-page) .container {\r\n    margin: 3.625rem 0 0 0;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  #wrap:not(.no-responsive, .float-page) .container {\r\n    margin-top: 100px;\r\n  }\r\n}\r\n\r\n/* content */\r\n.content {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  width: calc(100% - 282px);\r\n  padding-left: 0.5rem;\r\n}\r\n\r\n@media screen and (max-width: 940px) {\r\n  #wrap:not(.no-responsive, .float-page) .content {\r\n    width: 100%;\r\n    padding-left: 0;\r\n    margin-top: 44px;\r\n  }\r\n}\r\n\r\n/* 컨텐츠 개별 box */\r\n.box {\r\n  background: #fff;\r\n  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);\r\n  border-radius: 4px;\r\n  position: relative;\r\n  overflow-x: hidden;\r\n}\r\n.box__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: auto;\r\n  padding: 32px 24px 24px;\r\n  border-bottom: 1px solid #dde2e9;\r\n}\r\n.box__header .select {\r\n  width: auto;\r\n  height: auto;\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  line-height: 1;\r\n  letter-spacing: -1px;\r\n  border: 0;\r\n  border-radius: 0;\r\n}\r\n.box__header .select .selected {\r\n  padding: 0;\r\n}\r\n.box__header .select .selected .arrow {\r\n  margin-left: 4px;\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  background: url(\"../img/icon_select_l.png\") no-repeat center center;\r\n  background-size: 1.25rem 1.25rem;\r\n}\r\n.box__header .select.active .selected .arrow {\r\n  transform: rotate(180deg);\r\n}\r\n.box__header .select ul {\r\n  margin-top: 8px;\r\n  width: 214px !important;\r\n}\r\n.box__header .select ul li {\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 1.2;\r\n  letter-spacing: -0.4px;\r\n  color: #2a2c2f;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  padding: 15px 24px;\r\n  width: calc(100% - 48px) !important;\r\n  border-bottom: 1px solid #dde2e9;\r\n}\r\n.box__header .select ul li:last-child {\r\n  border-bottom: 0;\r\n}\r\n.box__header .select ul li:active {\r\n  font-weight: 700;\r\n  color: #0a78ff;\r\n}\r\n\r\n.box__title {\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  line-height: 1;\r\n  letter-spacing: -0.4px;\r\n  color: #2a2c2f;\r\n}\r\n.box__body {\r\n  position: relative;\r\n  padding: 24px;\r\n}\r\n.box__search {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: relative;\r\n}\r\n.box__search input[type=\"text\"] {\r\n  width: 100%;\r\n  border: 0;\r\n  font-weight: 700;\r\n  padding: 1px 38px 1px 16px;\r\n  border: 1px solid;\r\n  border-color: #909fb7 transparent;\r\n  border-radius: 0;\r\n}\r\n.box__search input[type=\"text\"]:focus {\r\n  border: 1px solid #0a78ff !important;\r\n}\r\n.box__search .btn-search {\r\n  position: absolute;\r\n  right: 12px;\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  border: 0;\r\n  background: url(\"../img/Icon_search.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.input__area .box__search {\r\n  width: 100%;\r\n}\r\n/* 삭제 버튼 함께 들어갈 때 */\r\n.treebar.box .box__search.input__direct input[type=\"text\"] {\r\n  padding-right: 58px;\r\n  width: calc(100% - 74px);\r\n}\r\n.treebar.box .box__search.input__direct .btn-delete {\r\n  right: 35px;\r\n  width: 24px;\r\n}\r\n/*라인 모두 들어간 타입*/\r\n.box__search.type-line {\r\n  margin: 12px 7px 0 8px;\r\n}\r\n.treebar.box .box__search.type-line input[type=\"text\"] {\r\n  border: 1px solid #909fb7;\r\n  border-radius: 4px;\r\n  padding-right: 58px;\r\n  width: calc(100% - 74px);\r\n}\r\n.treebar.box .box__search.type-line .btn-delete {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 35px;\r\n  background: url(\"../img/icon_deletecircle@3x.png\") no-repeat center center;\r\n  background-size: 14px 14px;\r\n  width: 24px;\r\n  height: 100%;\r\n  margin-left: 0;\r\n  z-index: 2;\r\n}\r\n\r\n/*포커스 갈때 디자인 변경*/\r\n.box__search.focus {\r\n  border: 1px solid #909fb7;\r\n  border-left: 0;\r\n  border-right: 0;\r\n}\r\n.box__search .focus__search {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: calc(100% - 91px);\r\n  border-right: 1px solid #909fb7;\r\n}\r\n.box__search .focus__search input[type=\"text\"] {\r\n  padding-right: 0;\r\n  border: 0;\r\n  width: calc(100% - 50px);\r\n}\r\n.box__search .focus__search input[type=\"text\"]:focus {\r\n  outline: none;\r\n  box-shadow: none;\r\n  -webkit-box-shadow: none;\r\n  border: 0 !important;\r\n}\r\n.box__search .focus__search span {\r\n  width: 50px;\r\n  text-align: right;\r\n  font-size: 14px;\r\n  color: #909fb7;\r\n  padding-right: 8px;\r\n}\r\n.box__search .focus__btn {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-right: 14px;\r\n  margin-left: 8px;\r\n}\r\n.box__search .focus__btn button {\r\n  border: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  background-size: 100%;\r\n}\r\n.box__search .focus__btn .arrow-up {\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url(\"../img/icon_arrowsmall.png\") no-repeat center center;\r\n}\r\n.box__search .focus__btn .arrow-down {\r\n  width: 20px;\r\n  height: 20px;\r\n  transform: rotate(180deg);\r\n  background: url(\"../img/icon_arrowsmall.png\") no-repeat center center;\r\n}\r\n.box__search .focus__btn .close {\r\n  margin-left: 8px;\r\n  background: url(\"../img/iocn_closesmall.png\") no-repeat center center;\r\n}\r\n\r\n@media screen and (max-width: 940px) {\r\n  #wrap:not(.no-responsive) .box {\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n  }\r\n  #wrap:not(.no-responsive) .box__header.flex-column.brd-bottom-0.pb-0 {\r\n    padding: 9px 0 0;\r\n  }\r\n}\r\n\r\n/* treebar */\r\n.treebar.box {\r\n  width: 280px;\r\n  /* min-height: 1006px; */\r\n  min-height: 1013px;\r\n  height: calc(100vh - 66px);\r\n  border: 0;\r\n  box-shadow: 0px 3px 8px rgba(144, 159, 183, 0.5);\r\n}\r\n.treebar.box .box__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: 2.938rem;\r\n  padding: 0 0.75rem 0 1rem;\r\n  border: 0;\r\n}\r\n.treebar.box .box__header .box__title {\r\n  font-size: 16px;\r\n}\r\n.treebar.box .box__search input[type=\"text\"] {\r\n  border-left: 0;\r\n  border-right: 0;\r\n}\r\n.treebar.box .box__search input[type=\"text\"]::placeholder {\r\n  opacity: 0.5;\r\n}\r\n.treebar.box .box__search input[type=\"text\"]:-ms-input-placeholder {\r\n  opacity: 0.5;\r\n}\r\n.treearea {\r\n  overflow-y: auto;\r\n  height: calc(100% - 81px);\r\n  /* height: 920px; */\r\n}\r\n.tree__title {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #2a2c2f;\r\n  background: #f0f2f4;\r\n  padding: 13px 16px;\r\n}\r\n.tree__title .highlight {\r\n  display: flex;\r\n  background: #e6f0ff;\r\n  border-radius: 4px;\r\n  color: #0a78ff;\r\n  padding: 8px;\r\n  margin: -8px;\r\n}\r\n.treearea .tree {\r\n  padding: 1.125rem 1.5rem 2.75rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n  color: #2a2c2f;\r\n}\r\n.treearea .tree ul {\r\n  margin-top: 1.125rem;\r\n}\r\n.treearea .tree ul li {\r\n  position: relative;\r\n}\r\n.treearea .tree ul.tree__depth2 li:first-child:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 6px;\r\n  left: -14px;\r\n  background-color: #e9edef;\r\n  width: 14px;\r\n  height: 1px;\r\n}\r\n.treearea .tree ul.tree__depth2 li::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 26px;\r\n  left: -14px;\r\n  background-color: #e9edef;\r\n  width: 14px;\r\n  height: 1px;\r\n}\r\n.treearea .tree ul.tree__depth2 li:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -20px;\r\n  left: -15px;\r\n  background-color: #e9edef;\r\n  width: 1px;\r\n  height: calc(100% + 46px);\r\n}\r\n.treearea .tree ul.tree__depth2 li:last-child::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -20px;\r\n  left: -15px;\r\n  background-color: #e9edef;\r\n  width: 1px;\r\n  height: 26px;\r\n}\r\n.treearea .tree ul.tree__depth3 li:first-child:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 6px;\r\n  left: -14px;\r\n  background-color: #e9edef;\r\n  width: 14px;\r\n  height: 1px;\r\n}\r\n.treearea .tree ul.tree__depth3 li::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 26px;\r\n  left: -14px;\r\n  background-color: #e9edef;\r\n  width: 14px;\r\n  height: 1px;\r\n}\r\n.treearea .tree ul.tree__depth3 li:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -20px;\r\n  left: -15px;\r\n  background-color: #e9edef;\r\n  width: 1px;\r\n  height: calc(100% + 47px);\r\n}\r\n.treearea .tree ul.tree__depth3 li:last-child::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -20px;\r\n  left: -15px;\r\n  background-color: #e9edef;\r\n  width: 1px;\r\n  height: 26px;\r\n}\r\n.tree__depth4::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  /* top: 20px; */\r\n  top: 40px;\r\n  left: 24px;\r\n  background-color: #e9edef;\r\n  width: 1px;\r\n  height: calc(100% - 46px);\r\n  /* height: calc(100% - 27px); */\r\n}\r\n.treearea .tree ul.tree__depth3 li:first-child .tree__depth4:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 19px;\r\n  left: 24px;\r\n  background-color: #e9edef;\r\n  width: 1px;\r\n  height: calc(100% - 26px);\r\n}\r\n.treearea .tree ul.tree__depth4 li {\r\n  padding-left: 42px;\r\n}\r\n.treearea .tree ul.tree__depth4 li:first-child:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 7px;\r\n  left: 5px;\r\n  background-color: #e9edef;\r\n  width: 14px;\r\n  height: 1px;\r\n}\r\n.treearea .tree ul.tree__depth4 li::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 27px;\r\n  left: 5px;\r\n  background-color: #e9edef;\r\n  width: 14px;\r\n  height: 1px;\r\n}\r\n.treearea .tree ul.tree__depth4 li:after {\r\n  content: none;\r\n}\r\n.treearea .tree ul.tree__depth4 li:last-child::after {\r\n  content: none;\r\n}\r\n.tree__depth4.container {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 45px;\r\n  left: 24px;\r\n  background-color: #e9edef;\r\n  width: 1px;\r\n  height: calc(100% - 52px);\r\n}\r\n.treearea .tree ul.tree__depth4 li label {\r\n  margin-left: -42px;\r\n}\r\n.treearea .tree ul li::before .treearea .tree ul li:last-child:before {\r\n  content: none;\r\n}\r\n.treearea .tree ul.tree__depth6 li::before {\r\n  content: none;\r\n}\r\n.treearea .tree li {\r\n  position: relative;\r\n  /* background: url(\"../img/treeview-line.gif\") 5px 8px no-repeat; */\r\n}\r\n.treearea .tree li:last-child::before {\r\n  height: 0;\r\n}\r\n.treearea .tree li + li {\r\n  padding-top: 1.25rem;\r\n}\r\n.treearea .tree strong {\r\n  margin-left: 0.563rem;\r\n  padding-left: 1.125rem;\r\n  font-weight: 400;\r\n}\r\n.treearea .tree a.on span {\r\n  color: #0a78ff;\r\n  font-weight: 500;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n.treearea .tree a.highlight span {\r\n  color: #0a78ff;\r\n  font-weight: 500;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n.treearea .tree li a.highlight::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 15px;\r\n  width: 100%;\r\n  height: 32px;\r\n  background: #e6f0ff;\r\n  border-radius: 4px;\r\n  z-index: 1;\r\n}\r\n.treearea .tree li:first-child a.highlight::after {\r\n  top: -9px;\r\n}\r\n.treearea .tree li:not(:first-child) a.highlight::after {\r\n  top: 11px;\r\n}\r\n.treearea .tree li ul.tree__depth2 li:first-child a.highlight::after {\r\n  top: -9px;\r\n}\r\n.treearea .tree li ul.tree__depth2 li:not(:first-child) a.highlight::after {\r\n  top: 11px;\r\n}\r\n.treearea .tree li ul.tree__depth3 li:first-child a.highlight::after {\r\n  top: -9px;\r\n}\r\n.treearea .tree li ul.tree__depth3 li:not(:first-child) a.highlight::after {\r\n  top: 11px;\r\n}\r\n.treearea .tree li ul.tree__depth4 li:first-child a.highlight::after {\r\n  top: -9px;\r\n}\r\n.treearea .tree li ul.tree__depth4 li:not(:first-child) a.highlight::after {\r\n  top: 11px;\r\n}\r\n\r\n.tree > li.tree__depth1 span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub1.png\") 0 center no-repeat;\r\n  background-size: 0.625rem 0.875rem;\r\n}\r\n.tree .tree__depth2 li span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub2.png\") 0 center no-repeat;\r\n  background-size: 0.563rem 0.875rem;\r\n}\r\n.tree .tree__depth3 li span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub3.png\") 0 center no-repeat;\r\n  background-size: 0.625rem 0.75rem;\r\n}\r\n.tree .tree__depth4 li span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub4.png\") 0 center no-repeat;\r\n  background-size: 0.625rem 0.75rem;\r\n}\r\n.tree > li.tree__depth1 a.on span,\r\n.tree > li.tree__depth1 a.highlight span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub1_on.png\") 0 center no-repeat;\r\n  background-size: 0.625rem 0.875rem;\r\n}\r\n.tree .tree__depth2 li a.on span,\r\n.tree .tree__depth2 li a.highlight span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub2_on.png\") 0 center no-repeat;\r\n  background-size: 0.563rem 0.875rem;\r\n}\r\n.tree .tree__depth3 li a.on span,\r\n.tree .tree__depth3 li a.highlight span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub3_on.png\") 0 center no-repeat;\r\n  background-size: 0.625rem 0.75rem;\r\n}\r\n.tree .tree__depth4 li a.on span,\r\n.tree .tree__depth4 li a.highlight span {\r\n  padding-left: 16px;\r\n  background: url(\"../img/icon_treesub4_on.png\") 0 center no-repeat;\r\n  background-size: 0.625rem 0.75rem;\r\n}\r\n.treebar.box.close {\r\n  width: 40px !important;\r\n}\r\n.treebar.close .box__title,\r\n.treebar.close .box__search,\r\n.treebar.close .treearea {\r\n  display: none;\r\n}\r\n.treebar.close .box__header {\r\n  padding: 0 0.75rem;\r\n  justify-content: center;\r\n  border-bottom: 0;\r\n}\r\n.treebar.close .btn-tree {\r\n  position: relative;\r\n  display: flex;\r\n  width: auto;\r\n  height: auto;\r\n  background: url(\"../img/icon_treeopen.png\") no-repeat center center;\r\n}\r\n.treebar.close .btn-tree::after {\r\n  content: \"Beyond X™ Enable\";\r\n  writing-mode: vertical-rl;\r\n  -ms-writing-mode: tb-rl;\r\n  margin-top: 12.5rem;\r\n  font-weight: 700;\r\n}\r\n.container.type2 .treebar.close .btn-tree::after {\r\n  content: \"Beyond X™ Enable\";\r\n}\r\n.container.type2 .treebar.close .btn-tree::before {\r\n  content: \"™\";\r\n  transform: rotate(90deg);\r\n  position: absolute;\r\n  background: #fff;\r\n  width: 16px;\r\n  height: 20px;\r\n  bottom: 60px;\r\n  font-size: 0.875rem;\r\n  color: #2a2c2f;\r\n  font-weight: 700;\r\n}\r\n.treebar__toggleBtn,\r\n.select__toggleBtn {\r\n  display: none;\r\n}\r\n.tree ul {\r\n  list-style: none;\r\n  padding-left: 1.25rem;\r\n}\r\n.tree ul.tree__depth6 {\r\n  padding-left: 1.95rem;\r\n}\r\n.tree label {\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  color: #2a2c2f;\r\n}\r\n.tree label:hover {\r\n  color: #0a78ff;\r\n}\r\n.tree label:before {\r\n  content: \"\";\r\n  width: 0.688rem;\r\n  height: 0.688rem;\r\n  padding-right: 7px;\r\n  display: inline-block;\r\n  /* margin-left: -1.563rem;\r\n  margin-right: 1.75rem; */\r\n  background: url(\"../img/icon_tree_m.png\") no-repeat 0 center;\r\n  background-size: 0.688rem 0.688rem;\r\n}\r\n.tree .tree__depth5 label:before,\r\n.tree .tree__depth6 label:before {\r\n  padding-right: 0.75rem;\r\n}\r\n.tree ul.tree__depth6 li {\r\n  background-position: 0px 0px;\r\n  padding-left: 1.25rem;\r\n  padding-top: 1.438rem;\r\n  margin-top: -0.438rem;\r\n  margin-left: -1.625rem;\r\n}\r\n.tree ul.tree__depth6 li:first-child {\r\n  margin-top: -1.5rem;\r\n}\r\n.tree label.lastTree:before {\r\n  background: none;\r\n  padding-right: 14px;\r\n}\r\n.tree input[type=\"checkbox\"]:checked + a label.lastTree:before {\r\n  background: none;\r\n}\r\n.tree input[type=\"checkbox\"]:checked + a label.lastTree:hover:before {\r\n  background: none;\r\n}\r\n.tree label:hover:before {\r\n  content: \"\";\r\n  background: url(\"../img/icon_tree_m.png\") no-repeat 0 center;\r\n}\r\n.tree .tree__depth4 label:hover:before {\r\n  background: none;\r\n}\r\n.tree input[type=\"checkbox\"] {\r\n  display: none;\r\n}\r\n.tree input[type=\"checkbox\"]:checked ~ ul {\r\n  display: none;\r\n}\r\n.tree input[type=\"checkbox\"]:checked + a label:before {\r\n  content: \"\";\r\n  background: url(\"../img/icon_tree_p.png\") no-repeat 0 center;\r\n  background-size: 0.688rem 0.688rem;\r\n}\r\n.tree input[type=\"checkbox\"]:checked + a label:hover:before {\r\n  content: \"\";\r\n  background: url(\"../img/icon_tree_p.png\") no-repeat 0 center;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .treebar.box {\r\n    height: auto;\r\n  }\r\n}\r\n@media screen and (max-width: 940px) {\r\n  .treebar.box {\r\n    display: none;\r\n  }\r\n  .treebar.box.active {\r\n    display: block;\r\n    position: fixed;\r\n    top: 101px;\r\n    width: 100% !important;\r\n    border: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    z-index: 100;\r\n    box-shadow: none;\r\n  }\r\n  .treebar.box .box__header {\r\n    display: none;\r\n  }\r\n  .treearea {\r\n    height: calc(100vh - 146px);\r\n  }\r\n  .treebar__toggleBtn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    position: fixed;\r\n    top: 50px;\r\n    left: 0;\r\n    padding: 0 20px;\r\n    width: calc(100% - 40px);\r\n    height: 51px;\r\n    background: #fff;\r\n    border-bottom: 1px solid #dde2e9;\r\n    z-index: 20;\r\n    cursor: pointer;\r\n  }\r\n  .select__toggleBtn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    position: fixed;\r\n    top: 102px;\r\n    left: 0;\r\n    padding: 0 20px;\r\n    width: calc(100% - 40px);\r\n    height: 51px;\r\n    background: #fff;\r\n    border-bottom: 1px solid #dde2e9;\r\n    z-index: 20;\r\n    cursor: pointer;\r\n  }\r\n  .treebar__toggleBtn p,\r\n  .select__toggleBtn p {\r\n    display: block;\r\n    width: calc(100% - 64px);\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    line-height: 1.2;\r\n    letter-spacing: -0.4px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .treebar__toggleBtn:after,\r\n  .select__toggleBtn::after {\r\n    content: \"\";\r\n    width: 24px;\r\n    height: 24px;\r\n    margin-left: 40px;\r\n    background: url(\"../img/icon_select_l.png\") no-repeat center center;\r\n    background-size: 100%;\r\n  }\r\n  .treebar__toggleBtn.active:after,\r\n  .select__toggleBtn.active:after {\r\n    content: \"\";\r\n    transform: rotate(180deg);\r\n  }\r\n  .treebar .box__search input[type=\"text\"] {\r\n    height: 40px;\r\n    border-color: #dde2e9;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  .treebar__toggleBtn {\r\n    top: 100px;\r\n  }\r\n  .select__toggleBtn {\r\n    top: 152px;\r\n  }\r\n  .treebar.box.active {\r\n    top: 151px;\r\n  }\r\n  #wrap:not(.float-page, .no-responsive) .treebar.box.menutype.active {\r\n    top: 152px;\r\n  }\r\n  #wrap:not(.float-page, .no-responsive) .selectbar.box.menutype.active {\r\n    top: 194px;\r\n  }\r\n}\r\n\r\n/********************************************** For small screen, 반응형 **********************************************/\r\n\r\n@media screen and (min-width: 500px) and (max-width: 768px) {\r\n  header {\r\n    height: 50px;\r\n  }\r\n  .container {\r\n    min-height: calc(100vh - 59px);\r\n    margin-top: 58px;\r\n  }\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .header__userinfo {\r\n    top: 50px;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  header {\r\n    padding-top: 50px;\r\n    justify-content: flex-end;\r\n  }\r\n  .header__title,\r\n  .header__title.beyoundx {\r\n    background: none;\r\n    width: calc(100% - 48px);\r\n    padding: 0;\r\n    margin: 0;\r\n    font-size: 20px;\r\n  }\r\n  .header__right {\r\n    margin-right: 10px;\r\n  }\r\n  .header__left {\r\n    flex: 1;\r\n  }\r\n  header h1 {\r\n    text-align: center;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    height: auto;\r\n  }\r\n  header:has(.header__title.beyoundx) h1 {\r\n    width: calc(100% - 48px);\r\n    font-weight: 500;\r\n  }\r\n  .header__userinfo {\r\n    top: 100px;\r\n    right: 0;\r\n  }\r\n  .header__userinfo li {\r\n    padding: 15px 0 16px;\r\n  }\r\n  .header__alarm {\r\n    width: 100%;\r\n    height: calc(100vh - 100px);\r\n    top: 100px;\r\n  }\r\n  /* .header__alarm .alarm__list {\r\n    max-height: calc(100vh - 147px);\r\n  } */\r\n  .navbar {\r\n    top: 6.25rem;\r\n  }\r\n  .navbar__menu {\r\n    left: -100%;\r\n    width: 100%;\r\n    top: 6.25rem;\r\n    height: calc(100% - 6rem);\r\n  }\r\n  .navbar__toggleBtn {\r\n    width: 36px;\r\n    height: 36px;\r\n    margin-left: 12px;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  .header__userinfo {\r\n    top: 90px;\r\n  }\r\n  .header__alarm {\r\n    top: 90px;\r\n    height: calc(100vh - 90px);\r\n  }\r\n  .menu-slide {\r\n    top: 146px;\r\n    height: calc(100vh - 162px);\r\n  }\r\n  /* .header__alarm .alarm__list {\r\n    max-height: calc(100vh - 133px);\r\n  } */\r\n}\r\n@media screen and (max-width: 414px) {\r\n  .navbar {\r\n    top: 100px;\r\n  }\r\n  .navbar__menu {\r\n    top: 100px;\r\n    height: calc(100% - 100px);\r\n  }\r\n}\r\n@media screen and (max-width: 360px) {\r\n  header h1 {\r\n    padding-left: 5px;\r\n  }\r\n}\r\n@media screen and (max-width: 320px) {\r\n  input[type=\"checkbox\"] + label {\r\n    font-size: 0.875rem;\r\n    padding-left: 1.438rem;\r\n  }\r\n  input[type=\"checkbox\"] + label:before {\r\n    width: 1.125rem;\r\n    height: 1.125rem;\r\n    top: -2px;\r\n  }\r\n  /* input[type=\"checkbox\"]:checked + label:after {\r\n    top: -2px;\r\n  } */\r\n  .header__right {\r\n    margin-right: 0.5rem;\r\n  }\r\n}\r\n\r\n/* footer */\r\n#wrap > footer {\r\n  background: #26282e;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n#wrap > footer .footer-wrap {\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  min-height: 180px;\r\n  width: 100%;\r\n  max-width: 1230px;\r\n  padding: 20px 0 40px;\r\n}\r\n#wrap > footer .footer-wrap .top,\r\n#wrap > footer .footer-wrap .bottom {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n#wrap > footer h1 {\r\n  width: 148px;\r\n  height: 20px;\r\n}\r\n#wrap > footer h1 > img {\r\n  width: auto;\r\n  height: 100%;\r\n}\r\n.familysite {\r\n  position: relative;\r\n  width: 168px;\r\n  height: 36px;\r\n  background: #26282e;\r\n}\r\n.familysite a.tit {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: calc(100% - 16px);\r\n  height: 100%;\r\n  padding: 0 8px;\r\n  font-size: 13px;\r\n  line-height: 16px;\r\n  letter-spacing: -0.4px;\r\n  color: #dde2e9;\r\n}\r\n.familysite a:after {\r\n  content: \"\";\r\n  width: 16px;\r\n  height: 16px;\r\n  background: url(\"../img/icon_arrow_gray10.svg\") no-repeat right center;\r\n  background-size: 100%;\r\n}\r\n.familysite .sitelist {\r\n  display: none;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 36px;\r\n  z-index: 1;\r\n  width: 100%;\r\n  max-height: 144px;\r\n  overflow-y: auto;\r\n  background: #41444a;\r\n}\r\n.familysite .sitelist::-webkit-scrollbar-thumb {\r\n  background-color: #34363c;\r\n}\r\n.familysite .sitelist a {\r\n  display: block;\r\n  padding: 10px 8px;\r\n  height: 100%;\r\n  font-size: 12px;\r\n  letter-spacing: -0.04em;\r\n  line-height: 1.33;\r\n  color: #dde2e9;\r\n}\r\n.familysite .sitelist li:hover a {\r\n  background: #34363c;\r\n}\r\n.familysite .sitelist li:active a {\r\n  background: #26282e;\r\n}\r\n.familysite.active .sitelist {\r\n  display: block;\r\n}\r\n.familysite.active a:after {\r\n  transform: rotate(180deg);\r\n}\r\n.familysite.active {\r\n  background: #41444a;\r\n}\r\n\r\n#wrap > footer .footer-wrap .top .right {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n}\r\n#wrap > footer .footer-wrap .top .right .btn-txt {\r\n  font-size: 13px;\r\n  line-height: 2.15;\r\n  letter-spacing: -0.01em;\r\n  color: #dde2e9;\r\n}\r\n#wrap > footer .footer-wrap .top .right .btn-txt strong {\r\n  font-weight: 500;\r\n}\r\n#wrap > footer .footer-wrap .bottom {\r\n  align-items: flex-end;\r\n}\r\n#wrap > footer .footer-wrap .bottom ul {\r\n  margin-top: 16px;\r\n}\r\n#wrap > footer .footer-wrap .bottom ul > li {\r\n  font-size: 12px;\r\n  line-height: 1.7;\r\n  letter-spacing: -0.04em;\r\n  color: #909fb7;\r\n}\r\n#wrap > footer .footer-wrap .bottom ul > li a {\r\n  font-weight: 500;\r\n}\r\n.copy {\r\n  font-size: 11px;\r\n  color: #909fb7;\r\n  font-weight: 350;\r\n  line-height: 1.7;\r\n  letter-spacing: -0.02em;\r\n}\r\n#wrap > footer .footer-wrap .copy strong {\r\n  font-weight: 500;\r\n}\r\n\r\n@media screen and (max-width: 1278px) {\r\n  #wrap > footer {\r\n    padding: 0 40px;\r\n    width: calc(100% - 80px);\r\n  }\r\n}\r\n@media screen and (max-width: 820px) {\r\n  #wrap > footer .footer-wrap .bottom {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    margin-top: 20px;\r\n  }\r\n  #wrap > footer .footer-wrap .bottom .left,\r\n  #wrap > footer .footer-wrap .bottom .right {\r\n    width: 100%;\r\n  }\r\n  #wrap > footer .footer-wrap .bottom .right {\r\n    margin-top: 16px;\r\n    text-align: right;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  #wrap > footer {\r\n    padding: 0 20px;\r\n    width: calc(100% - 40px);\r\n  }\r\n}\r\n@media screen and (max-width: 350px) {\r\n  #wrap > footer .footer-wrap .top {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n  }\r\n  #wrap > footer .footer-wrap .top .right {\r\n    width: 100%;\r\n    text-align: right;\r\n    margin-top: 10px;\r\n  }\r\n}\r\n.foot-btn {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n}\r\n.foot-btn .btn-txt {\r\n  font-size: 13px;\r\n  line-height: 2.15;\r\n  letter-spacing: -0.01em;\r\n  color: #7783a1;\r\n}\r\n.foot-btn .btn-txt:hover,\r\n.foot-btn .btn-txt:active {\r\n  font-weight: 500;\r\n}\r\n\r\n/* ck 에디터 관련 */\r\n.ck.ck-editor,\r\n.ck.ck-reset.ck-editor {\r\n  height: 100% !important;\r\n}\r\n.ck.ck-editor__main {\r\n  height: calc(100% - 31px) !important;\r\n  border-top: 1px solid #dde2e9 !important;\r\n}\r\n.ck.ck-editor__main .ck.ck-content.ck-editor__editable {\r\n  height: calc(100% - 16px) !important;\r\n  padding: 16px 24px 0 !important;\r\n  border: 0 !important;\r\n  border-radius: 0 0 4px 4px !important;\r\n  box-shadow: none !important;\r\n}\r\n.ck.ck-editor__main h2 {\r\n  font-size: 1.5em !important;\r\n}\r\n.ck.ck-editor__main h3 {\r\n  font-size: 1.17em !important;\r\n}\r\n.ck.ck-editor__main h2,\r\n.ck.ck-editor__main h3,\r\n.ck.ck-editor__main h4 {\r\n  font-weight: bold !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n  /* margin: revert;\r\n  padding: revert; */\r\n}\r\n.ck.ck-editor__main h4,\r\n.ck.ck-editor__main p,\r\n.ck.ck-editor__main span {\r\n  font-size: 1em !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {\r\n  box-shadow: none !important;\r\n}\r\n.ck.ck-toolbar {\r\n  border: 0 !important;\r\n  height: 30px !important;\r\n}\r\n.ck.ck-toolbar.ck-toolbar_vertical {\r\n  height: auto !important;\r\n  width: auto !important;\r\n}\r\n.ck.ck-toolbar > .ck-toolbar__items {\r\n  height: auto !important;\r\n}\r\n.ck i {\r\n  display: unset !important;\r\n  width: unset !important;\r\n  height: unset !important;\r\n}\r\n.ck dl,\r\n.ck ol,\r\n.ck table,\r\n.ck ul,\r\n.ck p,\r\n.ck span {\r\n  margin: revert;\r\n  padding: revert;\r\n}\r\n.ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items > .ck {\r\n  width: auto !important;\r\n}\r\n.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item {\r\n  margin: 0 !important;\r\n}\r\n.ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items > .ck {\r\n  width: auto !important;\r\n}\r\n.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,\r\n.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {\r\n  right: 0 !important;\r\n  left: unset !important;\r\n}\r\n.ck.ck-list-styles-list {\r\n  padding: 0 !important;\r\n}\r\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\r\n  max-width: unset !important;\r\n}\r\n.ck.ck-toolbar > .ck-toolbar__items > :not(.ck-toolbar__line-break),\r\n.ck.ck-toolbar > .ck.ck-toolbar__grouped-dropdown {\r\n  margin-bottom: 0 !important;\r\n  margin-top: 0 !important;\r\n}\r\n.ck.ck-toolbar > .ck-toolbar__items > :not(.ck-toolbar__line-break) {\r\n  margin-right: 0;\r\n}\r\n@media screen and (max-width: 499px) {\r\n  .ck.ck-toolbar-dropdown > .ck-dropdown__panel {\r\n    max-width: var(--ck-toolbar-dropdown-max-width) !important;\r\n  }\r\n  .write-area .editarea .editbox-wrap .ck.ck-toolbar {\r\n    height: auto !important;\r\n  }\r\n}\r\n@media screen and (max-width: 400px) {\r\n  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,\r\n  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {\r\n    left: 0 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
